"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  var dependencies = ["ngResource", "ui.router", "ui.bootstrap", "ui.gravatar", "ui.utils.masks", "permission", "permission.ui", "idf.br-filters", "monospaced.qrcode", "angular-clipboard", "highcharts-ng", "ngFileUpload", "daterangepicker", "angularMoment"];

  var submodules = ["admin.templates", "admin.permissions", "admin.resources", "admin.directives", "admin.services", "admin.login", "admin.home", "admin.customers", "admin.subscriptions", "admin.reports", "admin.newsletters", "admin.campaigns"];

  var submodules = ["admin.templates", "admin.permissions", "admin.resources", "admin.directives", "admin.services", "admin.login", "admin.home", "admin.customers", "admin.subscriptions", "admin.reports", "admin.campaigns"];

  angular.module("admin", dependencies.concat(submodules)).config(function (uibPaginationConfig) {
    uibPaginationConfig.firstText = "Primeira";
    uibPaginationConfig.previousText = "Anterior";
    uibPaginationConfig.nextText = "Próxima";
    uibPaginationConfig.lastText = "Última";
  }).config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise("/");

    $stateProvider.state("admin", {
      url: "/",
      templateUrl: "views/admin/master.html",
      controller: "AdminCtrl",
      controllerAs: "ctrl"
    });

    $stateProvider.state("logout", {
      url: "/logout",
      controller: function controller($state, UserManager) {
        UserManager.abandon();
        $state.go("login");
      }
    });
  }).config(function ($sceDelegateProvider) {
    $sceDelegateProvider.resourceUrlWhitelist(["self", "http://local.canalenergia.com.br:8080/**", "http://localhost:8880/**", "https://www.canalenergia.com.br/**"]);
  }).config(function ($httpProvider) {
    $httpProvider.interceptors.push(function ($q, $injector, config) {
      var state = {
        isRefreshing: false,
        refreshPromise: null,
        refreshAttempted: false,
        isRetrying: false
      };

      var isApiUrl = function isApiUrl(url) {
        return url && url.includes(config.api);
      };
      var isLoginSupervisor = function isLoginSupervisor(url) {
        return url && url.includes("auth-backoffice/login");
      };
      var isRefreshUrl = function isRefreshUrl(url) {
        return url && url.includes("/auth/refresh");
      };
      var shouldHandle401 = function shouldHandle401(rejection) {
        return rejection && rejection.status === 401 && rejection.config && isApiUrl(rejection.config.url) && !isLoginSupervisor(rejection.config.url) && !isRefreshUrl(rejection.config.url);
      };

      var resetState = function resetState() {
        state.isRefreshing = false;
        state.refreshPromise = null;
        state.refreshAttempted = false;
        state.isRetrying = false;
      };

      var logout = function logout(rejection) {
        var $state = $injector.get("$state");
        var UserManager = $injector.get("UserManager");

        UserManager.abandon();
        $state.go("login");
        resetState();
        return $q.reject(rejection || new Error("Token refresh failed"));
      };

      var refreshToken = function refreshToken() {
        var $http = $injector.get("$http");
        var UserManager = $injector.get("UserManager");
        var refreshTokenValue = localStorage.getItem("ce-admin-refresh-token");

        if (!refreshTokenValue) {
          return $q.reject(new Error("No refresh token available"));
        }

        state.isRefreshing = true;
        state.refreshAttempted = true;

        state.refreshPromise = $http.post(config.api + "/api/v1/auth/refresh", {
          refreshToken: refreshTokenValue
        }).then(function (res) {
          var data = res.data.data;
          UserManager.setTokens(data.idToken, data.accessToken);
          state.isRefreshing = false;
          return data;
        }).catch(function (error) {
          resetState();
          logout(error);
          return $q.reject(error);
        });

        return state.refreshPromise;
      };

      var retryRequest = function retryRequest(originalConfig) {
        var $http = $injector.get("$http");
        var newAccessToken = localStorage.getItem("ce-admin-access-token");

        if (!newAccessToken) {
          resetState();
          return $q.reject(new Error("No access token after refresh"));
        }

        state.isRetrying = true;
        var retryConfig = angular.copy(originalConfig);
        retryConfig.headers.Authorization = "Bearer " + newAccessToken;

        return $http(retryConfig).then(function (response) {
          resetState();
          return response;
        }).catch(function (error) {
          resetState();
          if (error && error.status === 401) {
            return logout(error);
          }
          return $q.reject(error);
        });
      };

      return {
        request: function request(_request) {
          if (!isApiUrl(_request.url)) return _request;

          if (isLoginSupervisor(_request.url)) {
            resetState();
          }

          var token = localStorage.getItem("ce-admin-access-token");
          if (token) {
            _request.headers.Authorization = "Bearer " + token;
          }

          return _request;
        },

        response: function response(_response) {
          if (state.isRetrying) state.isRetrying = false;
          return _response;
        },

        responseError: function responseError(rejection) {
          if (!shouldHandle401(rejection)) {
            return $q.reject(rejection);
          }

          if (state.refreshAttempted || state.isRetrying) {
            return logout(rejection);
          }

          if (!state.isRefreshing) {
            refreshToken();
          }

          return state.refreshPromise.then(function () {
            return retryRequest(rejection.config);
          });
        }
      };
    });
  }).run(function ($transitions, UserManager) {
    $transitions.onStart({ to: "admin.**" }, function (trans) {
      return UserManager.getCurrent().then(function (session) {}, function () {
        return trans.router.stateService.target("login");
      });
    });
  }).run(function ($locale) {
    $locale.NUMBER_FORMATS.CURRENCY_SYM += " ";
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = submodules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var submod = _step.value;

      var deps = ["permission", "permission.ui"];
      if (submod === "admin.subscriptions" || submod === "admin.directives") {
        deps.push("admin.services");
      }
      angular.module(submod, deps);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
})();

angular.module("admin").component("customerCard", {
  templateUrl: "views/components/customerCard.html",
  bindings: {
    customer: "=",
    edit: "&",
    changeAdmin: "&",
    deleteCustomer: "&"
  },
  controller: function controller(SupervisorResource, AdminCustomersResource, $uibModal, RemovalReasons) {
    this.getRemovalReasonLabel = function (reason) {
      if (!reason) return null;
      return RemovalReasons.getLabel(reason);
    };
    this.impersonate = function (customer) {
      SupervisorResource.impersonate({
        userId: customer.id
      }, function (session) {
        $uibModal.open({
          component: "impersonateModal",
          resolve: {
            session: session
          }
        });
      });
    };
    this.takedown = function (customer) {
      AdminCustomersResource.takedown({
        id: customer.id
      }, function () {
        void 0;
      });
    };
    this.handleChangeAdmin = function (customer) {
      if (this.changeAdmin) {
        this.changeAdmin({ u: customer });
      }
    };
  }
}).component("changeAdminModal", {
  templateUrl: "views/subscriptions/change_admin.html",
  controller: function controller(SubscriptionDetailsResource) {
    this.changeAdmin = function () {
      var _this = this;

      SubscriptionDetailsResource.changeAdmin({
        subscriptionNumber: Number(this.resolve.subscriptionNumber),
        administratorId: this.resolve.customer.id
      }, function () {
        _this.close();
      }, function (err) {
        return _this.error = err.data.message;
      });
    };
  },
  bindings: {
    resolve: "<",
    dismiss: "&",
    close: "&"
  }
}).component("impersonateModal", {
  bindings: {
    close: "&",
    resolve: "<"
  },
  controllerAs: "ctrl",
  controller: function controller(config) {
    this.site = config.site;

    this.access = function () {
      var session = this.resolve.session;
      var params = [];

      if (session.data.accessToken) {
        params.push("accessToken=" + encodeURIComponent(session.data.accessToken));
      }
      if (session.data.idToken) {
        params.push("idToken=" + encodeURIComponent(session.data.idToken));
      }
      if (session.data.refreshToken) {
        params.push("refreshToken=" + encodeURIComponent(session.data.refreshToken));
      }

      var url = this.site + "/impersonate?" + params.join("&");
      window.open(url, "_blank");
    };
  },
  templateUrl: "views/components/impersonate.html"
}).component("organizationDetails", {
  bindings: {
    organization: "=",
    invoiceAddress: "=",
    invoiceRecipients: "="
  },
  templateUrl: "views/components/organizationDetails.html",
  controller: function controller($uibModal, config, CnpjUtils) {
    this.config = config;
    this.formatCnpj = function (cnpj) {
      return CnpjUtils.format(cnpj);
    };
    this.editOrganization = function () {
      var _this2 = this;

      $uibModal.open({
        controller: "EditOrganizationCtrl",
        controllerAs: "$ctrl",
        templateUrl: "views/subscriptions/edit-organization.html",
        resolve: {
          organization: function organization() {
            return _this2.organization;
          }
        }
      });
    };
  }
}).component("faBoolean", {
  bindings: {
    value: "="
  },
  controller: function controller($scope) {
    this.$onInit = function () {
      if (this.value) {
        this.text = "Sim";
        this.cls = "fa-boolean-yes";
        this.icon = "fa-check";
      } else {
        this.text = "Não";
        this.cls = "fa-boolean-no";
        this.icon = "fa-times";
      }
    };
  },
  transclude: true,
  template: "<span class=\"fa-boolean\" ng-class=\"$ctrl.cls\">\n        <i class=\"fa\" ng-class=\"$ctrl.icon\"></i> {{$ctrl.text}}\n    </span>"
}).component("email", {
  bindings: {
    to: "<"
  },
  template: "   <a href=\"mailto:{{$ctrl.to}}\">\n                <i class=\"fa fa-envelope-o\"></i>\n                {{$ctrl.to}}\n            </a>"
}).component("phoneNumber", {
  bindings: {
    phone: "="
  },
  template: "\n    <span ng-if=\"$ctrl.phone\"><i class=\"fa fa-phone\"></i>\n\n    <span ng-if=\"$ctrl.phone.ddd\">\n    {{($ctrl.phone.ddd + '' + $ctrl.phone.number) | brPhoneNumber}}\n    </span>\n    <span ng-if=\"!$ctrl.phone.ddd\">\n    {{$ctrl.phone | brPhoneNumber}}\n    </span>\n    </span>\n  "
}).component("address", {
  bindings: {
    address: "="
  },
  template: "\n    <span ng-if=\"$ctrl.address\">\n    {{$ctrl.address.street}} <span ng-if=\"$ctrl.address.number\">, {{$ctrl.address.number}}</span> {{$ctrl.address.complement}}\n    <br />{{$ctrl.address.neighborhood}} - {{$ctrl.formatCep($ctrl.address.postalCode)}}\n    <br />{{$ctrl.address.city}} - {{$ctrl.address.state}}\n    </span>\n    ",
  controller: function controller() {
    this.formatCep = function (cep) {
      if (!cep) return "";

      var digits = String(cep).replace(/\D/g, "").padStart(8, "0");
      if (digits.length !== 8) return cep;

      return digits.slice(0, 5) + "-" + digits.slice(5);
    };
  }
}).component("monthNav", {
  bindings: {
    onChange: "&",
    current: "="
  },
  template: "\n     <div class=\"month-picker\">\n                <a href ng-click=\"$ctrl.backwards()\" class=\"btn btn-link\"><i class=\"fa fa-chevron-left\"></i></a>\n                <span class=\"month\">{{$ctrl.current | date:'MMMM/yyyy'}}</span>\n\n                <a ng-click=\"$ctrl.towards()\" href class=\"btn btn-link\"><i class=\"fa fa-chevron-right\"></i></a>\n            </div>\n    ",
  controller: function controller() {
    this.current = new Date();

    this.towards = function () {
      this.current.setMonth(this.current.getMonth() + 1);
      this.onChange(this.current);
    };
    this.backwards = function () {
      this.current.setMonth(this.current.getMonth() - 1);
      this.onChange(this.current);
    };
  }
}).component("resultsCount", {
  bindings: {
    count: "="
  },
  template: "\n        {{$ctrl.count}}\n                <span ng-if=\"$ctrl.count === 1\">\n                    resultado encontrado\n                </span>\n                <span ng-if=\"$ctrl.count > 1\">\n                resultados encontrados\n                </span>\n        "
});

angular.module('admin.directives').directive('compare', function () {
  return {
    require: 'ngModel',
    link: function link(scope, element, attrs, ctrl) {
      var modelToMatch = attrs.compare;
      scope.$watch(attrs.compare, function () {
        ctrl.$validate();
      });

      ctrl.$validators.compare = function (modelValue, viewValue) {

        var comparedValue = scope.$eval(modelToMatch);
        return viewValue === comparedValue;
      };
    }
  };
}).directive('uiCeCnpjMask', ['CnpjUtils', function (CnpjUtils) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModel) {
      ngModel.$formatters.push(function (modelValue) {
        if (!modelValue) return modelValue;
        return CnpjUtils.format(modelValue);
      });

      ngModel.$parsers.push(function (viewValue) {
        if (!viewValue) return viewValue;

        var clean = CnpjUtils.clean(viewValue);
        var formatted = CnpjUtils.format(clean);

        if (viewValue !== formatted) {
          ngModel.$setViewValue(formatted);
          ngModel.$render();
        }

        return clean;
      });

      ngModel.$validators.cnpj = function (modelValue) {
        return CnpjUtils.isValid(modelValue);
      };
    }
  };
}]);

angular.module('admin.permissions').run(function (PermPermissionStore, UserManager, config) {

  var permissionSets = {
    "atendimento": ['admin.subscriptions', 'admin.campaigns', "customer.changeCredentials", "customer.impersonate", "subscription.change_admin", "reports.subscriptions", 'reports', "reports.basic", 'reports.myce', 'reports.subscriptions_flow', "admin.prospects", 'subscription.freeplay.view', 'subscription.freeplay.edit', 'reports.commercial_report', 'reports.removed_subordinates'], "financeiro": ['admin.subscriptions', 'admin.campaigns', "subscription.vindi.edit", "customer.impersonate", 'reports', "reports.revenues",
    //'subscription.revenues',
    "reports.subscriptions", 'reports.subscriptions_flow', 'reports.commercial_report'], "admin": ['admin.subscriptions', 'admin.campaigns', "admin.logs", 'reports', 'reports.favorites', 'reports.myce', "subscription.import_users", 'reports.subscriptions_flow', 'reports.removed_subordinates'], "publicidade": ['reports', "reports.mailing", 'admin.campaigns', 'admin.campaigns.edit', 'trials.import'], "users": ['admin.users.view', 'admin.users.edit']
  };

  var checkPermission = function checkPermission(permission) {

    return new Promise(function (resolve, reject) {
      UserManager.getCurrent().then(function (u) {
        var roles = u.roles;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = roles[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var role = _step2.value;

            var roleSet = permissionSets[role];

            if (!roleSet) {
              continue;
            }
            if (roleSet.indexOf(permission) >= 0) resolve();
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        reject();
      }, function () {
        return reject();
      });
    });
  };

  for (var role in permissionSets) {
    var permissions = permissionSets[role];

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = permissions[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var permission = _step3.value;

        PermPermissionStore.definePermission(permission, checkPermission);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }
});

angular.module("admin.resources").factory("SupervisorResource", function (config, $resource) {
  return $resource(config.api + "/api/supervisor", {}, {
    login: {
      method: "POST",
      url: config.api + "/api/v1/auth-backoffice/login"
    },
    changePassword: {
      method: "PATCH",
      url: config.api + "/api/v1/backoffice-user-management/change-password"
    },
    impersonate: {
      method: "POST",
      url: config.api + "/api/v1/auth/impersonate-user",
      isArray: false
    }
  });
}).factory("SubscriptionListResource", function (config, $resource) {
  return $resource(config.api + "/api/v1/subscriptions", {}, {
    query: {
      method: "GET",
      url: config.api + "/api/v1/subscriptions/paginated",
      isArray: false
    }
  });
}).factory("SubscriptionDetailsResource", function (config, $resource) {
  return $resource(config.api + "/api/v1/subscriptions", {}, {
    get: {
      method: "GET",
      url: config.api + "/api/v1/subscriptions/:subscriptionNumber/details",
      isArray: false
    },
    getSubscribers: {
      method: "GET",
      url: config.api + "/api/v1/subscriptions/:subscriptionNumber/subscribers/paginated",
      isArray: false
    },
    getVindi: {
      method: "GET",
      isArray: false,
      url: config.api + "/api/AdminSubscriptions/GetVindiDetails"
    },
    changeAdmin: {
      method: "PATCH",
      url: config.api + "/api/v1/backoffice-user-management/subscriptions/change-admin"
    },
    getTrials: {
      url: config.api + "/api/Trial/Get",
      method: "GET",
      isArray: true
    }
  });
}).factory("ChangeCustomerCredentialsResource", function (config, $resource) {
  return $resource(config.api + "/api/v1/user-management/users/:id", { id: "@id" }, {
    update: {
      method: "PUT"
    }
  });
}).factory("SubordinateUserResource", function (config, $resource) {
  return $resource(config.api + "/api/v1/backoffice-user-management/subordinates/:id", { id: "@id" }, {
    suspend: {
      method: "DELETE",
      url: config.api + "/api/v1/backoffice-user-management/subordinates/:id/suspend",
      params: {
        lang: "pt-BR"
      }
    }
  });
}).factory("VindiResource", function (config, $resource) {
  return $resource(config.api + "/api", {}, {
    getCustomer: {
      isArray: false,
      method: "GET",
      url: config.api + "/api/AdminSubscriptions/GetVindiCustomer/:id"
    },
    getSubscription: {
      isArray: false,
      method: "GET",
      url: config.api + "/api/AdminSubscriptions/GetVindiSubscription/:id"
    },
    changeVindi: {
      method: "POST",
      url: config.api + "/api/AdminSubscriptions/ChangeVindi"
    }
  });
}).factory("AdminLogsResource", function (config, $resource) {
  return $resource(config.api + "/api/AdminLogs", {}, {
    query: {
      url: config.api + "/api/AdminLogs/GetLogs",
      isArray: false
    }
  });
}).factory("AdminCustomersResource", function (config, $resource) {
  return $resource(config.api + "/api/AdminCustomers/", {}, {
    takedown: {
      method: "GET",
      url: config.api + "/api/AdminCustomers/Takedown/:id"
    },
    deleteCustomer: {
      method: "DELETE",
      url: config.api + "/api/AdminCustomers/delete/:id"
    }
  });
}).factory("TypeaheadResource", function (config, $resource) {
  return $resource(config.api + "/api/", {}, {
    customers: {
      url: config.api + "/api/AdminCustomers/Typeahead",
      isArray: true,
      method: "GET"
    },
    supervisors: {
      url: config.api + "/api/Supervisor/Typeahead",
      isArray: true,
      method: "GET"
    }
  });
}).factory("ReportsResource", function (config, $resource) {
  return $resource(config.api, {}, {
    basicCustomers: {
      url: config.api + "/api/v1/reports/basic-users-exceeding-views",
      isArray: false,
      method: "GET"
    },
    myce: {
      url: config.api + "/api/adminMyCeReport/GetReport",
      isArray: false,
      method: "GET"
    },
    favoritesChart: {
      url: config.api + "/api/AdminFavoritePostsReport/GetChart",
      isArray: true,
      method: "GET"
    },
    favorites: {
      url: config.api + "/api/AdminFavoritePostsReport/GetReport",
      isArray: false,
      method: "GET"
    },
    revenueReport: {
      url: config.api + "/api/AdminRevenueReport/GetReportData",
      isArray: true,
      method: "GET"
    },
    revenueChart: {
      url: config.api + "/api/AdminRevenueReport/GetChart",
      isArray: false,
      method: "GET"
    },
    futureRevenues: {
      url: config.api + "/api/AdminRevenueReport/GetFutureRevenues",
      isArray: true,
      method: "GET"
    },
    missingRevenues: {
      url: config.api + "/api/AdminRevenueReport/GetMissingSubscriptions",
      isArray: true,
      method: "GET"
    },
    subscriptionFlowCharts: {
      url: config.api + "/api/v1/reports/subscription-flow/charts",
      isArray: false,
      method: "GET"
    },
    subscriptionFlowData: {
      url: config.api + "/api/v1/reports/subscription-flow/data",
      isArray: false,
      method: "GET"
    },
    getMailing: {
      url: config.api + "/api/AdminMailingReport/GetMailing",
      method: "GET",
      isArray: true
    },
    activityLogs: {
      url: config.api + "/api/v1/activity-logs",
      method: "GET",
      isArray: false
    }
  });
}).factory("SubscriptionRevenueResource", function (config, $resource) {
  return $resource(config.api + "/api/AdminSubscriptionRevenue", {}, {
    query: { isArray: false }
  });
}).factory("SubscriptionCustomersImport", function (config, $resource) {
  return $resource(config.api + "/api/AdminSubscriptionUpload/CompleteCustomerImport");
}).factory("CampaignsResource", function (config, $resource) {
  return $resource(config.api + "/api/v1/campaigns", {}, {
    create: {
      method: "POST",
      url: config.api + "/api/v1/campaigns"
    },
    update: {
      method: "PUT",
      url: config.api + "/api/v1/campaigns/:id"
    },
    query: {
      method: "GET"
    },
    getDetails: {
      url: config.api + "/api/v1/campaigns/:id/details"
    },
    get: {
      url: config.api + "/api/v1/campaigns/:id"
    }
  });
}).factory("ActivitiesResource", function (config, $resource) {
  return $resource(config.api + "/api/v1/reference-data/professional-activities", {}, {
    query: {
      method: "GET",
      isArray: false
    }
  });
}).factory("PlansResource", function (config, $resource) {
  return $resource(config.api + "/api/v1/plans", {}, {
    query: {
      method: "GET",
      isArray: false
    }
  });
}).factory("TrialPlans", function (config, $resource) {
  return $resource(config.api + "/api/admintrial/getplans");
}).factory("FreePlayResource", function (config, $resource) {
  return $resource(config.api + "/api/v1/free-plays", {}, {
    query: {
      method: "GET",
      isArray: false
    },
    get: {
      url: config.api + "/api/v1/free-plays/subscription/:subscriptionNumber",
      method: "GET",
      isArray: false
    },
    delete: {
      url: config.api + "/api/v1/free-plays/:id",
      method: "DELETE"
    },
    create: {
      url: config.api + "/api/v1/free-plays",
      method: "POST"
    },
    update: {
      url: config.api + "/api/v1/free-plays/:id",
      method: "PUT"
    }
  });
}).factory("SupervisorsResource", function (config, $resource) {
  return $resource(config.api + "/api/v1/backoffice-user-management", {}, {
    query: {
      method: "GET",
      isArray: false
    },
    toggle: {
      method: "PATCH",
      url: config.api + "/api/v1/backoffice-user-management/toggle/:id"
    },
    create: {
      method: "POST",
      url: config.api + "/api/v1/backoffice-user-management"
    },
    update: {
      method: "PUT",
      url: config.api + "/api/v1/backoffice-user-management/:id"
    },
    changePassword: {
      method: "PATCH",
      url: config.api + "/api/v1/backoffice-user-management/change-password"
    },
    changePasswordById: {
      method: "PATCH",
      url: config.api + "/api/v1/backoffice-user-management/:id/password"
    }
  });
});

angular.module('admin.subscriptions').controller('TrialCtrl', function ($http, $uibModalInstance, Upload, config, TrialPlans) {

  this.viewMode = 'upload';

  this.steps = [];

  this.upload = {
    planId: 2
  };

  this.hasNext = function () {

    switch (this.viewMode) {
      case 'success':
        return false;
      case 'summary':
        return this.summary.successful > 0;
      case 'upload':
        return Boolean(this.upload.file);
    }

    return true;
  };

  this.next = function () {
    var me = this;
    switch (this.viewMode) {

      case 'upload':
        this.processing = true;

        this.import().then(function (response) {
          me.summary = response.data;
          me.summary.selectedPlan = me.plans.find(function (p) {
            return p.id === me.upload.planId;
          });
          me.processing = false;
          me.advanceStep('summary');
        }, function () {});
        break;
      case 'summary':
        {
          me.processing = true;
          this.complete().then(function () {
            me.processing = false;
            me.advanceStep('success');
          }, function (e) {
            me.processing = false;
          });
          break;
        }
    }
  };

  this.advanceStep = function (newStep) {
    this.viewMode = newStep;
    this.steps.push(this.viewMode);
  };

  this.previous = function () {
    this.steps.splice(this.steps.length - 1, 1);
    this.viewMode = this.steps[this.steps.length - 1];
  };

  this.dismiss = function () {
    $uibModalInstance.dismiss();
  };

  this.close = function () {
    $uibModalInstance.close();
  };

  this.selectFile = function (file) {
    this.upload.file = file;
  };

  this.import = function () {

    var req = {
      url: config.api + '/api/AdminTrial/Upload',
      method: 'POST',
      data: {
        planId: this.upload.planId
      },
      file: this.upload.file
    };
    return Upload.upload(req);
  };

  this.exportToExcel = function () {
    var _this3 = this;

    var date = new Date();

    var filename = "Planilha_" + date.valueOf() + ".xlsx";
    this.isExporting = true;
    $http({
      url: config.api + '/api/AdminTrial/Export',
      method: 'GET',
      responseType: 'arraybuffer'
    }).then(function (res) {
      _this3.isExporting = false;
      res.headers();
      var url = URL.createObjectURL(new Blob([res.data], { type: 'arraybuffer' }));
      var a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.target = '_blank';
      a.click();
    }, function () {
      _this3.isExporting = false;
    });
  };
  this.complete = function () {

    return $http({
      url: config.api + '/api/AdminTrial/Complete',
      method: 'POST',
      params: {
        planId: this.upload.planId
      }
    });
  };

  this.init = function () {
    var _this4 = this;

    this.steps.push(this.viewMode);

    TrialPlans.query(function (p) {
      _this4.plans = p;
    });
  };

  this.init();
});
angular.module('admin').value('vindiPaymentTypes', [{ id: 'bank_slip', label: 'Boleto' }, { id: 'credit_card', label: 'Cartão de Crédito' }, { id: 'deposit', label: 'Depósito' }, { id: 'cash', label: 'Dinheiro' }]);
angular.module("admin.campaigns").controller("CampaignsListCtrl", function (CampaignsResource, $uibModal) {
  this.pagination = {
    page: 1,
    pageSize: 10
  };

  this.campaigns = [];
  this.metadata = {};
  this.loading = false;

  this.loadCampaigns = function () {
    var _this5 = this;

    this.loading = true;
    var params = {
      page: this.pagination.page,
      limit: this.pagination.pageSize
    };

    CampaignsResource.query(params, function (response) {
      _this5.loading = false;
      if (response && response.data) {
        _this5.campaigns = response.data.data || [];
        _this5.metadata = response.data.metadata || {};
        return;
      }

      _this5.campaigns = [];
      _this5.metadata = {};
    });
  };

  this.createCampaign = function () {
    var _this6 = this;

    $uibModal.open({
      templateUrl: "views/campaigns/edit.html",
      controller: "CampaignsEditModalCtrl",
      controllerAs: "ctrl",
      resolve: {
        mode: function mode() {
          return "create";
        },
        campaignId: null
      }
    }).result.then(function () {
      return _this6.loadCampaigns();
    });
  };

  this.edit = function (cp) {
    var _this7 = this;

    $uibModal.open({
      templateUrl: "views/campaigns/edit.html",
      controller: "CampaignsEditModalCtrl",
      controllerAs: "ctrl",
      resolve: {
        mode: function mode() {
          return "edit";
        },
        campaignId: cp.id
      }
    }).result.then(function () {
      return _this7.loadCampaigns();
    });
  };

  this.loadCampaigns();
}).config(function ($stateProvider) {
  $stateProvider.state("admin.campaigns", {
    url: "campaigns",
    controller: "CampaignsListCtrl",
    controllerAs: "ctrl",
    templateUrl: "views/campaigns/view.html",
    data: {
      permissions: {
        only: "admin.campaigns"
      }
    }
  });
});

angular.module('admin.campaigns').controller('CampaignDetailsCtrl', function ($stateParams, CampaignsResource) {

  this.loadDetails = function () {
    var _this8 = this;

    CampaignsResource.getDetails({
      id: $stateParams.id
    }, function (data) {
      _this8.campaign = data.data.campaign;
      _this8.subscriptions = data.data.subscriptions || [];
    });
  };
  this.loadDetails();
}).config(function ($stateProvider) {
  $stateProvider.state('admin.campaignDetails', {
    url: 'campaigns/{id}',
    controller: 'CampaignDetailsCtrl',
    controllerAs: 'ctrl',
    templateUrl: 'views/campaigns/details.html'
  });
});
angular.module("admin.campaigns").controller("CampaignsEditModalCtrl", function (mode, campaignId, PlansResource, CampaignsResource, $uibModalInstance, moment, $timeout, $document) {
  var _this9 = this;

  var ctrl = this;
  this.alerts = [];

  var scrollToTop = function scrollToTop() {
    $timeout(function () {
      var modalWindow = $document[0].querySelector('[uib-modal-window="modal-window"]');
      if (modalWindow) {
        modalWindow.scrollTop = 0;
        modalWindow.scrollTo && modalWindow.scrollTo(0, 0);
      }
    }, 100);
  };

  switch (mode) {
    case "create":
      this.title = "Nova Promoção";
      this.model = {
        cycles: null,
        campaign: {
          isActive: true
        }
      };

      PlansResource.query({
        type: "pj"
      }, function (data) {
        ctrl.model.campaignDiscounts = data.data.map(function (plan) {
          return {
            plan: plan,
            enabled: true,
            unitPrice: plan.monthlyPrice / 100
          };
        });
      });

      break;
    case "edit":
      {
        this.title = "Editar Promoção";
        PlansResource.query({
          type: "pj"
        }, function (plans) {
          CampaignsResource.get({ id: campaignId }, function (response) {
            var campaignDiscounts = response.data.campaignDiscounts;

            _this9.model = {
              campaign: response.data,
              campaignDiscounts: [],
              cycles: response.data.cycles,
              period: {
                startDate: moment.utc(response.data.startDate).format('YYYY-MM-DD'),
                endDate: moment.utc(response.data.endDate).format('YYYY-MM-DD')
              }
            };

            var _loop = function _loop(plan) {
              var discount = campaignDiscounts.find(function (discount) {
                return discount.planId === plan.id;
              });

              if (discount) {
                discount.enabled = true;
                discount.unitPrice = discount.unitPrice / 100;
                discount.plan = plan;
                _this9.model.campaignDiscounts.push(discount);
                return "continue";
              }

              _this9.model.campaignDiscounts.push({
                plan: plan,
                enabled: false,
                unitPrice: null
              });
            };

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = plans.data[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var plan = _step4.value;

                var _ret = _loop(plan);

                if (_ret === "continue") continue;
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          });
        });
        break;
      }
  }
  this.dismiss = function () {
    $uibModalInstance.dismiss();
  };
  this.save = function (frm) {
    var _this10 = this;

    frm.$setSubmitted();

    if (!frm.$valid) {
      this.alerts = [{
        message: "Por favor, preencha todos os campos obrigatórios antes de salvar.",
        type: "danger"
      }];

      scrollToTop();

      return;
    }

    this.model.campaign.startDate = moment(this.model.period.startDate).format("YYYY-MM-DD HH:mm:ss");
    this.model.campaign.endDate = moment(this.model.period.endDate).format("YYYY-MM-DD HH:mm:ss");

    var payload = {
      name: this.model.campaign.name,
      code: this.model.campaign.code,
      description: this.model.campaign.description,
      startDate: this.model.campaign.startDate,
      endDate: this.model.campaign.endDate,
      isActive: this.model.campaign.isActive,
      cycles: this.model.cycles,
      campaignDiscounts: this.model.campaignDiscounts.filter(function (discount) {
        return discount.enabled;
      }).map(function (discount) {
        return {
          campaignId: discount.campaignId || undefined,
          planId: discount.plan.id,
          unitPrice: discount.unitPrice * 100
        };
      })
    };

    this.alerts = [];

    if (mode === "create") {
      CampaignsResource.create(payload, function () {
        _this10.alerts = [];
        $uibModalInstance.close();
      }, function (err) {
        _this10.alerts = [{
          message: err.data && err.data.message || "Erro ao criar promoção",
          type: "danger"
        }];

        scrollToTop();
      });
    } else {
      CampaignsResource.update({ id: campaignId }, payload, function () {
        _this10.alerts = [];
        $uibModalInstance.close();
      }, function (err) {
        _this10.alerts = [{
          message: err.data && err.data.message || "Erro ao editar promoção",
          type: "danger"
        }];

        scrollToTop();
      });
    }
  };
});

angular.module("admin").controller("AdminCtrl", function ($state, UserManager, config, $uibModal) {
  var _this11 = this;

  this.site = config.site;
  UserManager.getCurrent().then(function (session) {
    _this11.currentUser = session;
  }, function () {
    $state.go("login");
  });

  this.getInitials = function (name) {
    if (!name) return "";

    var parts = name.trim().split(/\s+/);

    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }

    return parts[0][0].toUpperCase();
  };

  this.changePassword = function () {
    $uibModal.open({
      templateUrl: "views/admin/changepassword.html",
      controller: "ChangePasswordCtrl",
      controllerAs: "ctrl"
    });
  };

  this.quickSearch = function () {
    $state.go("admin.subscriptionDetails", {
      subscriptionNumber: this.quickSub.number
    });
    delete this.quickSub.number;
  };
});

angular.module("admin").controller("ChangePasswordCtrl", function ($uibModalInstance, SupervisorResource) {
  this.form = {
    newPassword: "",
    confirmPassword: ""
  };

  this.dismiss = function () {
    $uibModalInstance.close();
  };

  this.change = function (frm) {
    var _this12 = this;

    this.submited = true;
    this.alerts = [];
    if (frm.$invalid) return;

    var payload = {
      password: this.form.newPassword,
      oldPassword: this.form.oldPassword
    };

    SupervisorResource.changePassword(payload, function () {
      _this12.form = {
        newPassword: "",
        confirmPassword: "",
        oldPassword: ""
      };
      _this12.submited = false;
      frm.$setPristine();
      frm.$setUntouched();

      _this12.alerts = [{
        message: "Senha alterada com sucesso! A nova senha foi registrada.",
        type: "success"
      }];
    }, function (err) {
      _this12.alerts = [{
        message: err.data.message || "Erro ao alterar senha",
        type: "danger"
      }];
    });
  };
});

angular.module('admin').controller('LogsCtrl', function ($uibModal, AdminLogsResource, TypeaheadResource) {

  this.currentMonth = new Date();
  this.searchParams = {};

  this.pagination = {
    page: 1,
    pageSize: 20
  };

  this.filters = {
    subscriptionNumber: null,
    customerId: null,
    supervisorId: null
  };

  this.changeMonth = function () {
    this.pagination.page = 1;
    this.loadData();
  };

  this.getCustomers = function (search) {
    var par = {
      search: search
    };
    var typeahead = TypeaheadResource.customers(par);
    return typeahead.$promise;
  };
  this.getSupervisors = function (search) {
    var par = { search: search };
    return TypeaheadResource.supervisors(par).$promise;
  };

  this.onSelectCustomer = function (item, model) {
    this.searchParams.customerId = item.id;
  };
  this.onCustomersChange = function () {
    if (!this.customer) delete this.searchParams.customerId;
  };

  this.onSelectSupervisor = function (item, model) {

    this.searchParams.supervisorId = item.id;
  };
  this.onSupervisorChange = function () {
    if (!this.supervisor) delete this.searchParams.supervisorId;
  };

  this.submitSearch = function () {
    this.pagination.page = 1;
    this.loadData();
  };

  this.loadData = function () {
    var _this13 = this;

    AdminLogsResource.query(angular.extend(this.searchParams, {
      page: this.pagination.page,
      pageSize: this.pagination.pageSize,
      period: this.currentMonth
    }), function (data) {
      _this13.results = data;
    }, function (err) {

      //this.errorMessage = err.data.message;
    });
  };

  this.showDetails = function (_log) {
    var instance = $uibModal.open({
      templateUrl: 'views/admin/logs/log_details.html',
      controllerAs: 'ctrl',
      controller: function controller(log, $uibModalInstance) {
        this.log = log;
        if (log.json) {
          var json = JSON.parse(log.json);
          var properties = [];
          for (var p in json) {
            properties.push({ key: p, value: json[p] });
          }

          this.properties = properties;
        }

        this.close = function () {
          $uibModalInstance.dismiss();
        };
      }, resolve: {
        log: function log() {
          return _log;
        }
      }
    });
  };

  this.loadData();
}).config(function ($stateProvider) {
  $stateProvider.state('admin.logs', {
    url: 'logs',
    templateUrl: 'views/admin/logs/view.html',
    controllerAs: 'ctrl',
    controller: 'LogsCtrl'
  });
});
angular.module('admin.customers', []).controller('EditCustomerModalCtrl', function ($uibModalInstance, ChangeCustomerCredentialsResource, $http, config, RemovalReasons, customer) {
  this.statusValues = [{ label: 'Novo', value: 'NEW' }, { label: 'Ativado', value: 'ACTIVATED' }, { label: 'Suspenso', value: 'SUSPENDED' }];

  // Cria as opções do dropdown de motivo de suspensão baseado nos labels
  this.removalReasons = [{ label: 'Selecione', value: null }, { label: RemovalReasons.labels.EXIT_FROM_COMPANY, value: 'EXIT_FROM_COMPANY' }, { label: RemovalReasons.labels.DEPARTMENT_CHANGE, value: 'DEPARTMENT_CHANGE' }, { label: RemovalReasons.labels.USER_REPLACEMENT, value: 'USER_REPLACEMENT' }, { label: RemovalReasons.labels.ACCESS_CHANGE, value: 'ACCESS_CHANGE' }, { label: RemovalReasons.labels.LICENSES_REDUCTION, value: 'LICENSES_REDUCTION' }];

  this.customer = customer;
  this.customerEdit = angular.copy(customer);
  this.customerEdit.cpf = _.padStart(this.customerEdit.cpf, 11, '0');

  // Garante que metadata seja copiado corretamente
  if (customer.metadata && !this.customerEdit.metadata) {
    this.customerEdit.metadata = angular.copy(customer.metadata);
  }

  // Verifica se o usuário já tem um motivo de suspensão setado (não permite editar)
  var originalRemovalReason = customer.removalReason || customer.metadata && customer.metadata.removalReason || null;
  this.hasRemovalReasonSet = !!originalRemovalReason;

  // Carrega o removalReason se existir (pode estar em removalReason ou metadata.removalReason)
  // Verifica primeiro no customer original, depois no customerEdit
  // Normaliza o valor para garantir que seja um código válido
  var rawRemovalReason = customer.removalReason || customer.metadata && customer.metadata.removalReason || this.customerEdit.removalReason || this.customerEdit.metadata && this.customerEdit.metadata.removalReason || null;

  if (rawRemovalReason) {
    // Converte label para código se necessário
    var normalizedCode = RemovalReasons.getCode(rawRemovalReason);
    this.customerEdit.removalReason = normalizedCode;
    // Armazena o código original para garantir que seja mantido
    this.originalRemovalReasonCode = normalizedCode;
  } else {
    this.customerEdit.removalReason = null;
    this.originalRemovalReasonCode = null;
  }

  if (this.customerEdit.status) {
    this.customerEdit.status = this.customerEdit.status.toUpperCase();
  }

  this.onStatusChange = function () {
    if (this.customerEdit.status !== 'SUSPENDED') {
      // Só limpa se não tiver motivo já setado
      if (!this.hasRemovalReasonSet) {
        this.customerEdit.removalReason = null;
      }
    } else if (this.customerEdit.status === 'SUSPENDED' && this.hasRemovalReasonSet) {
      // Se voltar para SUSPENDED e tiver motivo setado, restaura o valor original
      if (this.originalRemovalReasonCode) {
        this.customerEdit.removalReason = this.originalRemovalReasonCode;
      }
    }
  };

  this.cancel = function () {
    $uibModalInstance.dismiss();
  };

  this.save = function () {
    var _this14 = this;

    // Se o status for SUSPENDED e não tiver motivo setado no banco, usar o endpoint específico de suspend
    if (this.customerEdit.status === 'SUSPENDED' && !this.hasRemovalReasonSet) {
      if (!this.customerEdit.removalReason || this.customerEdit.removalReason === null) {
        this.alerts = [{
          message: 'Motivo da suspensão é obrigatório',
          type: 'danger'
        }];
        return;
      }

      // Garante que o removalReason seja uma string válida
      var removalReason = String(this.customerEdit.removalReason).trim();
      if (!removalReason) {
        this.alerts = [{
          message: 'Motivo da suspensão é obrigatório',
          type: 'danger'
        }];
        return;
      }

      $http({
        method: 'DELETE',
        url: config.api + '/api/v1/backoffice-user-management/subordinates/' + this.customer.id + '/suspend?lang=pt-BR',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          removalReason: removalReason
        },
        transformRequest: function transformRequest(data) {
          return angular.toJson(data);
        }
      }).then(function () {
        _this14.customer.status = _this14.customerEdit.status;
        $uibModalInstance.close();
      }, function (err) {
        _this14.alerts = [{
          message: err.data && err.data.message ? err.data.message : 'Erro ao suspender usuário',
          type: 'danger'
        }];
      });
    }

    // Para outros status, usar o endpoint normal de atualização
    var payload = {
      cpf: this.customerEdit.cpf.replace(/\D/g, ''), // Remove non-digits
      email: this.customerEdit.email
    };

    if (this.customerEdit.status) {
      payload.status = this.customerEdit.status.toUpperCase();
    }

    if (this.customerEdit.password) {
      payload.password = this.customerEdit.password;
    }

    ChangeCustomerCredentialsResource.update({ id: this.customer.id }, payload, function () {
      _this14.customer.email = _this14.customerEdit.email;
      _this14.customer.cpf = Number(_this14.customerEdit.cpf.replace(/\D/g, ''));
      _this14.customer.status = _this14.customerEdit.status;
      $uibModalInstance.close();
    }, function (err) {
      _this14.alerts = [{
        message: err.data.message,
        type: 'danger'
      }];
    });
  };
});

angular.module("admin.subscriptions").controller("FreeplayEdit", function ($uibModalInstance, FreePlayResource, fp) {
  this.model = {};

  if (fp) {
    if (fp.startDate) this.model.startDate = new Date(fp.startDate + 'T00:00:00');
    if (fp.endDate) this.model.endDate = new Date(fp.endDate + 'T00:00:00');
    this.model.id = fp.id;
    this.model.subscriptionNumber = fp.subscriptionNumber;
  } else {
    this.model.startDate = new Date();
  }

  this.dismiss = function () {
    $uibModalInstance.dismiss();
  };

  this.validateDates = function () {
    if (this.model.startDate && this.model.endDate) {
      return this.model.endDate >= this.model.startDate;
    }
    return true;
  };

  this.submit = function (frm) {
    frm.$setSubmitted(true);

    if (frm.$invalid) return;

    if (!this.validateDates()) {
      frm.endDate.$setValidity('dateRange', false);
      return;
    }
    frm.endDate.$setValidity('dateRange', true);

    var payload = {
      id: this.model.id,
      startDate: this.model.startDate.toISOString(),
      subscriptionNumber: this.model.subscriptionNumber,
      endDate: null
    };

    if (this.model.endDate) {
      payload.endDate = this.model.endDate.toISOString();
    }

    if (payload.id) {
      FreePlayResource.update({ id: payload.id }, payload, function () {
        $uibModalInstance.close();
      });
      return;
    }

    FreePlayResource.create(payload, function () {
      $uibModalInstance.close();
    });
  };
});

angular.module("admin.subscriptions").controller("FreeplayList", function ($uibModal, FreePlayResource, $location, $timeout) {
  this.pagination = {
    page: 1,
    pageSize: 10
  };

  this.freeplays = [];
  this.metadata = {};
  this.search = "";
  this.searchTimeout = null;

  var queryParams = $location.search();
  if (queryParams.search) {
    this.search = queryParams.search;
  }

  this.fetchData = function () {
    var _this15 = this;

    this.loading = true;
    var params = {
      page: this.pagination.page,
      limit: this.pagination.pageSize
    };

    if (this.search) {
      params.search = this.search;
    }

    FreePlayResource.query(params, function (response) {
      _this15.loading = false;
      if (response && response.data) {
        _this15.freeplays = response.data.data || [];
        _this15.metadata = response.data.metadata || {};
        return;
      }
      _this15.freeplays = [];
      _this15.metadata = {};
    });
  };

  this.onSearchChange = function () {
    var _this16 = this;

    this.loading = true;
    if (this.searchTimeout) {
      $timeout.cancel(this.searchTimeout);
    }
    this.pagination.page = 1;

    if (this.search) {
      $location.search({ search: this.search });
    } else {
      $location.search({});
    }

    this.searchTimeout = $timeout(function () {
      _this16.fetchData();
    }, 500);
  };

  this.openCreate = function (fp) {
    var _this17 = this;

    $uibModal.open({
      controller: "FreeplayEdit",
      controllerAs: "ctrl",
      templateUrl: "views/freeplay/edit.html",
      backdrop: "static",
      resolve: {
        fp: function fp() {
          return null;
        }
      }
    }).result.then(function () {
      _this17.fetchData();
    });
    return false;
  };

  this.openEdit = function (_fp, e) {
    var _this18 = this;

    e.preventDefault();
    $uibModal.open({
      controller: "FreeplayEdit",
      controllerAs: "ctrl",
      templateUrl: "views/freeplay/edit.html",
      backdrop: "static",
      resolve: {
        fp: function fp() {
          return _fp;
        }
      }
    }).result.then(function () {
      _this18.fetchData();
    });
    return false;
  };

  this.openDelete = function (freeplay, e) {
    var _this19 = this;

    e.preventDefault();
    var modal = $uibModal.open({
      templateUrl: "views/freeplay/delete.html",
      controller: function controller($uibModalInstance, fp, FreePlayResource) {
        this.close = function () {
          FreePlayResource.delete(fp, function () {
            $uibModalInstance.close();
          });
        };
        this.dismiss = function () {
          $uibModalInstance.dismiss();
        };
      },
      controllerAs: "ctrl",
      resolve: {
        fp: function fp() {
          return freeplay;
        }
      }
    });

    modal.result.then(function () {
      _this19.fetchData();
    });

    return false;
  };

  this.fetchData();
}).config(function ($stateProvider) {
  $stateProvider.state("admin.freeplays", {
    controller: "FreeplayList",
    controllerAs: "ctrl",
    templateUrl: "views/freeplay/list.html",
    url: "freeplay",
    data: {
      permissions: {
        only: "subscription.freeplay.view",
        redirectTo: "admin"
      }
    }
  });
});

angular.module('admin.home', []).controller('HomeCtrl', function ($state) {}).config(function ($stateProvider) {
  $stateProvider.state('admin.home', {
    templateUrl: 'views/home/view.html',
    controller: 'HomeCtrl',
    controllerAs: 'ctrl',
    url: 'home'
  });
});
angular.module('admin.login', []).controller('LoginCtrl', function ($state, SupervisorResource, UserManager) {
  var _this20 = this;

  this.model = {
    email: '',
    password: '',
    remember: false
  };

  this.qrdata = document.location.href.substring(0, document.location.href.indexOf('#'));

  this.submit = function (frm) {
    _this20.submitted = true;
    if (frm.$invalid) return;

    delete _this20.errorMessage;
    SupervisorResource.login(_this20.model, function (data) {
      UserManager.setCurrent(data, _this20.model.remember);

      $state.go('admin.home');
    }, function (err) {
      switch (err.status) {
        case 400:
        case 401:
          _this20.errorMessage = 'Usuário ou senha inválidos! Verifique os dados de acesso e tente novamente!';
          break;
        case 500:
          _this20.errorMessage = 'Ocorreu um erro ao validar seu acesso!';break;
      }
    });
  };
}).config(function ($stateProvider) {
  $stateProvider.state('login', {
    templateUrl: 'views/login/view.html',
    controller: 'LoginCtrl',
    controllerAs: 'ctrl',
    url: '/login'
  });
});
angular.module('admin.reports').controller('BasicReportCtrl', function ($http, config, ReportsResource) {

  this.init = function () {
    this.page = 1;
    this.showAll = false;
    var today = new Date();
    var dateFromSession = sessionStorage.getItem('reports.basic.period');
    if (dateFromSession) this.month = new Date(dateFromSession);else this.month = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0, 0);

    this.loadReport();
  };

  this.changePeriod = function () {

    sessionStorage.setItem("reports.basic.period", this.month.toISOString());
    this.loadReport(1);
  };

  this.loadReport = function (resetPage) {
    var _this21 = this;

    if (resetPage) this.page = 1;

    ReportsResource.basicCustomers({
      month: this.month,
      page: this.page,
      showAll: this.showAll,
      limit: 20
    }, function (response) {
      _this21.report = response.data;
    });
  };
  this.exportToExcel = function () {

    var mm = ('0' + (this.month.getMonth() + 1)).substr(-2);
    var yyyy = this.month.getFullYear();
    var filename = "UsuariosBasicos_" + yyyy + "-" + mm + ".csv";

    $http({
      url: config.api + '/api/v1/reports/basic-users-exceeding-views/export',
      params: {
        month: this.month,
        showAll: this.showAll
      },
      method: 'GET',
      responseType: 'arraybuffer'
    }).then(function (res) {

      res.headers();
      var url = URL.createObjectURL(new Blob([res.data], { type: 'arraybuffer' }));
      var a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.target = '_blank';
      a.click();
    });
  };

  this.init();
});
angular.module("admin.reports").controller("CommercialReportCtrl", function ($http, config, ReportsResource) {
  this.isExporting = false;

  this.generateExcel = function () {
    var _this22 = this;

    this.isExporting = true;
    $http({
      url: config.api + "/api/v1/reports/commercial/export",
      method: "GET",
      responseType: "arraybuffer"
    }).then(function (res) {
      var downloadFile = function downloadFile(_ref) {
        var blob = _ref.blob,
            fileName = _ref.fileName;

        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");

        a.href = url;
        a.download = fileName;

        a.dispatchEvent(new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false
        }));

        window.URL.revokeObjectURL(url);
      };

      _this22.isExporting = false;
      var blob = new Blob([res.data], {
        type: "text/csv;charset=utf-8;"
      });
      downloadFile({ blob: blob, fileName: "RelatorioComercial.csv" });
    }, function (error) {
      void 0;
      _this22.isExporting = false;
    });
  };
});

angular.module("admin.reports").controller("FavoritesReportCtrl", function ($http, config, ReportsResource, dateFilter) {
  this.page = 1;
  this.pageSize = 20;

  this.loadChart = function () {
    var _this23 = this;

    $http({
      url: config.api + "/api/v1/reports/favorite-posts/chart",
      method: "GET"
    }).then(function (response) {
      var data = response.data.data || response.data;
      if (!Array.isArray(data)) {
        data = [];
      }
      data = data.reverse();
      _this23.monthlyChart = {
        chart: {
          type: "line"
        },
        xAxis: {
          categories: data.map(function (p) {
            return dateFilter(p.period, "MMM/yyyy");
          })
        },
        series: [{
          data: data.map(function (c) {
            return c.posts;
          }),
          id: "posts_per_month",
          name: "Postagens favoritadas"
        }],
        title: {
          text: "Matérias favoritadas por mês"
        }
      };
    });
  };

  this.loadTable = function () {
    var _this24 = this;

    $http({
      url: config.api + "/api/v1/reports/favorite-posts",
      method: "GET",
      params: {
        page: this.page,
        pageSize: this.pageSize
      }
    }).then(function (response) {
      var data = response.data.data;
      _this24.report = {
        results: data.data,
        totalResults: data.metadata.total,
        pageSize: data.metadata.limit
      };
    });
  };

  this.exportToExcel = function () {
    var _this25 = this;

    this.isExporting = true;
    $http({
      url: config.api + "/api/v1/reports/favorite-posts/export",
      method: "GET",
      responseType: "arraybuffer"
    }).then(function (res) {
      var downloadFile = function downloadFile(_ref2) {
        var blob = _ref2.blob,
            fileName = _ref2.fileName;

        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");

        a.href = url;
        a.download = fileName;

        a.dispatchEvent(new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false
        }));

        window.URL.revokeObjectURL(url);
      };

      _this25.isExporting = false;
      var blob = new Blob([res.data], {
        type: "text/csv;charset=utf-8;"
      });
      downloadFile({ blob: blob, fileName: "QuemFavorita.csv" });
    }, function (error) {
      void 0;
      _this25.isExporting = false;
    });
  };

  this.init = function () {
    this.loadChart();
    this.loadTable();
  };

  this.init();
});

angular.module("admin.reports").controller("MailingReportCtrl", function ($http, config, ReportsResource, ActivitiesResource) {
  this.init = function () {
    var _this26 = this;

    ActivitiesResource.query(function (response) {
      _this26.activities = response.data;
    }, function (error) {
      void 0;
    });
  };

  this.clearForm = function () {
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = this.activities[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var a = _step5.value;
        a.selected = false;
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }
  };

  this.getActivityCodes = function () {
    var selected = this.activities.filter(function (x) {
      return x.selected;
    });
    var codes = selected.map(function (x) {
      return x.code;
    });
    return codes.join(",");
  };

  this.loadReport = function (resetPage) {
    var _this27 = this;

    ReportsResource.getMailing({
      activities: this.getActivityCodes()
    }, function (data) {
      _this27.mailings = data;
    });
  };
  this.exportToExcel = function () {
    var _this28 = this;

    var activityCodes = this.getActivityCodes();
    this.isExporting = true;

    $http({
      url: config.api + "/api/v1/reports/users-by-professional-activities",
      params: {
        activityIds: activityCodes
      },
      method: "GET",
      responseType: "arraybuffer"
    }).then(function (res) {
      var downloadFile = function downloadFile(_ref3) {
        var blob = _ref3.blob,
            fileName = _ref3.fileName;

        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");

        a.href = url;
        a.download = fileName;

        a.dispatchEvent(new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false
        }));

        window.URL.revokeObjectURL(url);
      };

      _this28.isExporting = false;
      var blob = new Blob([res.data], {
        type: "text/csv;charset=utf-8;"
      });
      downloadFile({ blob: blob, fileName: "CE_MalaDireta.csv" });
    }, function (error) {
      void 0;
      _this28.isExporting = false;
    });
  };

  this.init();
});

angular.module("admin.reports").controller("MyCeReportCtrl", function ($http, config, ReportsResource) {
  this.page = 1;
  this.pageSize = 20;

  this.categories = [{ key: "politica", label: "Política" }, { key: "negocios-e-empresas", label: "Negócios e Empresas" }, { key: "operacao", label: "Operação" }, { key: "expansao", label: "Expansão" }, { key: "mercado", label: "Mercado" }, { key: "geracao", label: "Geração", isSegment: true }, { key: "transmissao", label: "Transmissão", isSegment: true }, { key: "distribuicao", label: "Distribuição", isSegment: true }, { key: "comercializacao", label: "Comercialização", isSegment: true }];

  this.loadReport = function () {
    var _this29 = this;

    $http({
      url: config.api + "/api/v1/reports/customers-with-channels",
      method: "GET",
      params: {
        page: this.page,
        limit: this.pageSize
      }
    }).then(function (response) {
      var data = response.data.data;
      _this29.totals = data.totals;

      _this29.categories.map(function (x) {
        x.total = _this29.totals[x.key] || 0;
      });

      data.data.map(function (x) {
        x.categories = {};
        if (x.channels && Array.isArray(x.channels)) {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = x.channels[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var c = _step6.value;

              x.categories[c] = true;
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      });

      _this29.report = {
        results: data.data,
        totalResults: data.metadata.total,
        pageSize: data.metadata.limit
      };

      _this29.buildCharts();
    });
  };

  this.buildCharts = function () {
    this.barChart = {
      chart: {
        type: "bar"
      },
      xAxis: {
        categories: this.categories.map(function (c) {
          return c.label;
        })
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true
          }
        }
      },
      series: [{
        data: this.categories.map(function (c) {
          return c.total;
        }),
        id: "users",
        name: "Usuários"
      }],
      title: {
        text: "Classificação Geral"
      }
    };

    this.subjectsChart = {
      chart: {
        type: "pie"
      },
      series: [{
        data: this.categories.filter(function (c) {
          return !c.isSegment;
        }).map(function (c) {
          return {
            name: c.label,
            y: c.total
          };
        }),
        id: "users",
        name: "Usuários"
      }],
      title: {
        text: "Classificação Por Assunto"
      },
      plotOptions: {
        pie: {
          showInLegend: false
        }
      }
    };

    this.segmentsChart = {
      chart: {
        type: "pie"
      },
      series: [{
        data: this.categories.filter(function (c) {
          return c.isSegment;
        }).map(function (c) {
          return {
            name: c.label,
            y: c.total
          };
        }),
        id: "users",
        name: "Usuários"
      }],
      title: {
        text: "Classificação Por Segmento"
      },
      plotOptions: {
        pie: {
          showInLegend: false
        }
      }
    };
  };

  this.exportToExcel = function () {
    var _this30 = this;

    this.isExporting = true;
    $http({
      url: config.api + "/api/v1/reports/customers-with-channels/export",
      method: "GET",
      responseType: "arraybuffer"
    }).then(function (res) {
      var downloadFile = function downloadFile(_ref4) {
        var blob = _ref4.blob,
            fileName = _ref4.fileName;

        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");

        a.href = url;
        a.download = fileName;

        a.dispatchEvent(new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false
        }));

        window.URL.revokeObjectURL(url);
      };

      _this30.isExporting = false;
      var blob = new Blob([res.data], {
        type: "text/csv;charset=utf-8;"
      });
      downloadFile({ blob: blob, fileName: "MeuCanalEnergia.csv" });
    }, function (error) {
      void 0;
      _this30.isExporting = false;
    });
  };

  this.loadReport();
});

angular.module("admin.reports").controller("RemovedSubordinatesReportCtrl", function (dateRangePickerConfig, ReportsResource, $http, config, RemovalReasons) {
  var ctrl = this;

  ctrl.page = 1;
  ctrl.limit = 20;
  ctrl.loading = false;
  ctrl.search = "";
  ctrl.lang = "pt-BR";

  ctrl.datePickerOpts = angular.extend(angular.copy(dateRangePickerConfig), {
    eventHandlers: {
      "apply.daterangepicker": function applyDaterangepicker() {
        ctrl.page = 1;
        ctrl.loadReport();
      }
    }
  });

  ctrl.filter = {
    period: {
      startDate: moment().subtract(30, "day").toDate(),
      endDate: moment().toDate()
    }
  };

  ctrl.loadReport = function () {
    ctrl.loading = true;
    delete ctrl.report;

    var params = {
      page: ctrl.page,
      limit: ctrl.limit,
      action: "SUBORDINATE_REMOVED",
      lang: ctrl.lang
    };

    if (ctrl.search && ctrl.search.trim()) {
      params.search = ctrl.search.trim();
    }

    if (ctrl.filter.period && ctrl.filter.period.startDate) {
      params.startDate = moment(ctrl.filter.period.startDate).startOf("day").toISOString();
    }

    if (ctrl.filter.period && ctrl.filter.period.endDate) {
      params.endDate = moment(ctrl.filter.period.endDate).endOf("day").toISOString();
    }

    ReportsResource.activityLogs(params, function (response) {
      ctrl.loading = false;
      if (response && response.data && response.data.data) {
        ctrl.report = {
          data: response.data.data,
          metadata: response.data.metadata
        };
      } else {
        ctrl.report = {
          data: [],
          metadata: {
            total: 0,
            page: 1,
            limit: ctrl.limit,
            totalPages: 0
          }
        };
      }
    }, function (error) {
      ctrl.loading = false;
      void 0;
      ctrl.report = {
        data: [],
        metadata: {
          total: 0,
          page: 1,
          limit: ctrl.limit,
          totalPages: 0
        }
      };
    });
  };

  ctrl.searchReport = function () {
    ctrl.page = 1;
    ctrl.loadReport();
  };

  ctrl.changePage = function () {
    ctrl.loadReport();
  };

  ctrl.getRemovalReasonLabel = function (reason) {
    return RemovalReasons.getLabel(reason);
  };

  ctrl.init = function () {
    ctrl.loadReport();
  };

  ctrl.init();
});

angular.module('admin.reports').config(function ($stateProvider) {
  $stateProvider.state('admin.reports', {
    controller: function controller() {}, template: '<ui-view />'
  });

  function createPermissions(name) {
    return {
      permissions: { only: name }
    };
  }

  $stateProvider.state('admin.reports.basic', {
    url: 'reports/basic',
    controller: 'BasicReportCtrl',
    controllerAs: 'ctrl',
    templateUrl: 'views/reports/basic.html',
    data: createPermissions('reports.basic')
  }).state('admin.reports.myce', {
    url: 'reports/myce',
    controller: 'MyCeReportCtrl',
    controllerAs: 'ctrl',
    templateUrl: 'views/reports/myce.html',
    data: createPermissions('reports.myce')
  }).state('admin.reports.favs', {
    url: 'reports/favorites',
    controllerAs: 'ctrl',
    controller: 'FavoritesReportCtrl',
    templateUrl: 'views/reports/favorites.html',
    data: createPermissions('reports.favorites')
  }).state('admin.reports.revenues', {
    url: 'reports/revenues',
    controller: 'RevenuesReportCtrl',
    controllerAs: 'ctrl',
    templateUrl: 'views/reports/revenues.html',
    data: createPermissions('reports.revenues')
  }).state('admin.reports.revenue_report', {
    url: 'reports/revenues/:reportId',
    controller: 'RevenueReportDetailCtrl',
    controllerAs: 'ctrl',
    templateUrl: 'views/reports/revenues_detail.html',
    data: createPermissions('reports.revenues')
  }).state('admin.reports.subscriptions', {
    url: 'reports/subscriptions',
    controller: 'SubscriptionsFlowReportCtrl',
    controllerAs: 'ctrl',
    templateUrl: 'views/reports/subscriptions_flow.html',
    data: createPermissions('reports.subscriptions_flow')
  }).state('admin.reports.revenues2', {
    url: 'reports/revenues2',
    controller: 'RevenueReport2Ctrl',
    controllerAs: 'ctrl',
    templateUrl: 'views/reports/revenues2.html',
    data: createPermissions('reports.revenues')
  }).state('admin.reports.mailing', {
    url: 'reports/mailing',
    controller: 'MailingReportCtrl',
    controllerAs: 'ctrl',
    templateUrl: 'views/reports/mailing.html',
    data: createPermissions('reports.mailing')
  }).state('admin.reports.commercial', {
    url: 'reports/commercial',
    controller: 'CommercialReportCtrl',
    controllerAs: 'ctrl',
    templateUrl: 'views/reports/commercial.html',
    data: createPermissions('reports.commercial_report')
  }).state('admin.reports.removed_subordinates', {
    url: 'reports/removed_subordinates',
    controller: 'RemovedSubordinatesReportCtrl',
    controllerAs: 'ctrl',
    templateUrl: 'views/reports/removed_subordinates.html',
    data: createPermissions('reports.removed_subordinates')
  });
});

angular.module('admin.reports').controller('RevenuesReportCtrl', function (ReportsResource, dateRangePickerConfig, $http, config) {
  var _this31 = this;

  this.config = config;
  this.datePickerOpts = angular.extend(angular.copy(dateRangePickerConfig), {
    eventHandlers: {
      'apply.daterangepicker': function applyDaterangepicker() {
        _this31.loadReport();
      }
    }
  });

  this.initializeFilter = function () {
    this.filter = { period: {}, newSubs: true, oldSubs: true, monthly: true, yearly: true, query: '' };

    this.filter.period = {
      startDate: moment().subtract(30, 'day'),
      endDate: moment().endOf('day')
    };

    this.pagination = {
      currentPage: 1,
      pageSize: 50
    };

    this.futureFilter = {
      query: ''
    };

    this.futurePagination = {
      currentPage: 1,
      pageSize: 50
    };
  };

  this.loadReport = function () {
    var _this32 = this;

    var request = {
      startDate: this.filter.period.startDate.format('YYYY-MM-DD'),
      endDate: this.filter.period.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')
    };

    ReportsResource.revenueReport(request, function (data) {
      _this32.reportData = data;

      _this32.filterReport();
    }, function (err) {});
  };

  this.filterReport = function (page) {
    var _this33 = this;

    if (page) this.pagination.currentPage = page;

    var upperCaseQuery = this.filter.query.toUpperCase();
    this.filteredData = this.reportData.filter(function (x) {
      if (_this33.filter.newSubs != _this33.filter.oldSubs) if (_this33.filter.newSubs && !x.isNew) return false;else if (_this33.filter.oldSubs && x.isNew) return false;

      if (_this33.filter.monthly != _this33.filter.yearly) if (_this33.filter.monthly && x.intervalCount != 1) return false;else if (_this33.filter.yearly && x.intervalCount != 12) return false;

      if (upperCaseQuery) {
        if (_this33.filter.query == x.subscriptionNumber) return true;else if (x.customerName.toUpperCase().indexOf(upperCaseQuery) >= 0) return true;else return false;
      }

      return true;
    });

    this.updateTotals();

    this.pagination.totalItems = this.filteredData.length;

    var skip = (this.pagination.currentPage - 1) * this.pagination.pageSize;
    if (skip > this.pagination.totalItems) skip = 0;

    var paginated = this.filteredData.slice(skip, skip + this.pagination.pageSize);
    this.filteredData = paginated;
  };

  this.updateTotals = function () {
    var total = 0,
        totalNew = 0;

    this.filteredData.forEach(function (rev) {
      if (rev.isNew) totalNew += rev.amount;
      total += rev.amount;
    });

    this.totals = {
      quantity: this.filteredData.length,
      allSubscriptions: total,
      newSubscriptions: totalNew,
      oldSubscriptions: total - totalNew
    };
  };

  this.loadFutureRevenues = function () {
    var _this34 = this;

    if (!this.futureRevenues) ReportsResource.futureRevenues(function (data) {
      _this34.futureRevenues = data;
      _this34.filterFuture();
    });
  };

  this.loadMissingRevenues = function () {
    var _this35 = this;

    if (!this.missingRevenues) ReportsResource.missingRevenues(function (data) {
      _this35.missingRevenues = data;
    });
  };

  this.filterFuture = function (page) {

    if (page) this.futurePagination.currentPage = page;

    var filtered = this.futureRevenues;

    if (this.futureFilter.query) {
      var upperQuery = this.futureFilter.query.toUpperCase();
      filtered = filtered.filter(function (x) {
        if (x.subscriptionNumber == upperQuery) {
          return true;
        }

        if (x.customerName.toUpperCase().indexOf(upperQuery) >= 0) return true;

        return false;
      });
    }

    this.futurePagination.totalItems = filtered.length;

    var skip = (this.futurePagination.currentPage - 1) * this.futurePagination.pageSize;
    this.filteredFuture = filtered.slice(skip, skip + this.futurePagination.pageSize);
  };

  this.loadChart = function () {
    var _this36 = this;

    ReportsResource.revenueChart(function (data) {
      _this36.reportChart = {
        chart: {
          type: 'column'
        },
        colors: ['#5cb1e6', '#ff9900'],
        title: {
          text: 'Receitas Mês a Mês'
        },
        xAxis: {
          categories: data.categories
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Total financeiro'
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: Highcharts.theme && Highcharts.theme.textColor || 'gray'
            }
          }
        },
        legend: {
          align: 'right',
          x: -30,
          verticalAlign: 'top',
          y: 25,
          floating: true,
          backgroundColor: Highcharts.theme && Highcharts.theme.background2 || 'white',
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false
        }, plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              color: 'black' || Highcharts.theme && Highcharts.theme.dataLabelsColor || 'white'
            }
          }, series: {
            cursor: 'pointer'
          }

        },
        series: data.series

      };

      data.series.forEach(function (s) {
        s.events = {
          click: function click(e) {
            _this36.setFilterBySeries(e.point);
          }
        };
      });
    }, function (err) {});
  };

  this.setFilterBySeries = function (point) {
    var category = point.category;

    var months = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

    var parts = category.split('/');
    var month = months.indexOf(parts[0]);
    var year = parseInt(parts[1]);

    var date = new Date(year, month, 1, 0, 0, 0, 0);

    var period = {
      startDate: moment(date),
      endDate: moment(date).endOf('month')
    };
    this.filter.period = period;
    this.loadReport();
  };

  this.exportToExcel = function () {

    var request = {
      startDate: this.filter.period.startDate.format('YYYY-MM-DD'),
      endDate: this.filter.period.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      newSubs: this.filter.newSubs,
      oldSubs: this.filter.oldSubs,
      monthly: this.filter.monthly,
      yearly: this.filter.yearly
    };

    $http({
      url: config.api + '/api/AdminRevenueReport/GetExcel',
      params: request,
      method: 'GET',
      responseType: 'arraybuffer'
    }).then(function (res) {

      var filename = "ReceitasCanalEnergia_" + request.startDate + "_" + request.endDate.substring(0, 10) + ".xlsx";

      res.headers();
      var url = URL.createObjectURL(new Blob([res.data], { type: 'arraybuffer' }));
      var a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.target = '_blank';
      a.click();
    });
  };

  this.exportFutureToExcel = function () {

    $http({
      url: config.api + '/api/AdminRevenueReport/GetFutureExcel',
      method: 'GET',
      responseType: 'arraybuffer'
    }).then(function (res) {

      var filename = "AssinaturasAgendadas.xlsx";

      res.headers();
      var url = URL.createObjectURL(new Blob([res.data], { type: 'arraybuffer' }));
      var a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.target = '_blank';
      a.click();
    });
  };

  this.initializeFilter();
  this.loadReport();
  this.loadChart();
});

var RevenueReport2Ctrl = function () {
  _createClass(RevenueReport2Ctrl, [{
    key: "getMonthName",
    value: function getMonthName(month) {
      var d = new Date(2017, month - 1, 1);
      var name = this.dateFilter(d, 'MMMM');
      return name;
    }
  }, {
    key: "initializeMonths",
    value: function initializeMonths() {
      this.years = [];
      this.months = [];

      var date = new Date();
      for (var i = 2017; i <= date.getFullYear(); i++) {
        this.years.push(i);

        var first = i === 2017 ? 5 : 1;
        var last = i === date.getFullYear() ? date.getMonth() + 1 : 12;

        for (var j = first; j <= last; j++) {
          var name = this.getMonthName(j);
          var monthData = {
            year: i,
            month: j,
            monthName: name
          };
          this.months.push(monthData);
        }

        this.filter = {
          year: date.getFullYear(),
          month: date.getMonth() + 1
        };
      }
    }
  }, {
    key: "loadData",
    value: function loadData() {
      var _this37 = this;

      this.loading = true;
      this.errorMessage = null;
      this.successMessage = null;
      this.tableData = this.pageData = null;
      this.showPeriod = this.filter.all;

      var filterParams = Object.assign({}, this.filter);

      filterParams.all = String(this.filter.all !== undefined ? this.filter.all : false);

      var _arr = ['billingDate', 'dueDate', 'paymentDate'];
      for (var _i = 0; _i < _arr.length; _i++) {
        var dateField = _arr[_i];
        var date = filterParams[dateField];
        if (!!date) {
          date = moment(date).format('YYYY-MM-DD');
          filterParams[dateField] = date;
        }

        if (!date) {
          delete filterParams[dateField];
        }
      }

      filterParams.page = this.currentPage;
      filterParams.pageSize = this.pageSize;

      this.http({
        url: this.config.api + '/api/v1/reports/billing/data',
        params: filterParams,
        method: 'GET'
      }).then(function (res) {
        _this37.loading = false;
        _this37.tableData = [];
        _this37.metadata = null;
        if (res.data && res.data.data) {
          _this37.tableData = res.data.data.data || [];
          _this37.metadata = res.data.data.metadata || {};
        }
        _this37.updatePageData();
      }, function () {
        _this37.loading = false;
        _this37.errorMessage = "Não foi possível carregar o relatório!";
      });
    }
  }, {
    key: "submitTable",
    value: function submitTable() {
      this.currentPage = 1;
      this.loadData();
    }
  }, {
    key: "submitExcel",
    value: function submitExcel() {
      var _this38 = this;

      this.loading = true;
      this.tableData = this.pageData = null;
      this.errorMessage = null;
      this.successMessage = null;

      var filterParams = Object.assign({}, this.filter);

      filterParams.all = String(this.filter.all !== undefined ? this.filter.all : false);

      var _arr2 = ['billingDate', 'dueDate', 'paymentDate'];
      for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
        var dateField = _arr2[_i2];
        var date = filterParams[dateField];
        if (!!date) {
          date = moment(date).format('YYYY-MM-DD');
          filterParams[dateField] = date;
        }

        if (!date) {
          delete filterParams[dateField];
        }
      }

      this.http({
        url: this.config.api + '/api/v1/reports/billing/export',
        params: filterParams,
        method: 'GET',
        responseType: 'arraybuffer'
      }).then(function (res) {
        _this38.loading = false;
        res.headers();
        var url = URL.createObjectURL(new Blob([res.data], { type: 'arraybuffer' }));
        var a = document.createElement('a');
        a.href = url;
        a.download = "RelatorioFinanceiro_" + _this38.filter.month + "-" + _this38.filter.year + ".csv";
        a.target = '_blank';
        a.click();

        _this38.successMessage = "Relatório exportado com sucesso!";
      }, function () {
        _this38.loading = false;
        _this38.errorMessage = "Não foi possível gerar o relatório";
      });
    }
  }, {
    key: "submitChart",
    value: function submitChart() {
      var _this39 = this;

      this.chartsLoading = true;
      this.http({
        url: this.config.api + '/api/v1/reports/billing/charts',
        method: 'GET'
      }).then(function (res) {
        _this39.chartData = res.data.data;

        _this39.generateNewVsCanceledChart();
        _this39.generateActiveSubsChart();
        _this39.chartsLoading = false;
      }, function () {});
    }
  }, {
    key: "generateActiveSubsChart",
    value: function generateActiveSubsChart() {
      var _this40 = this;

      var categories = [];
      var activeSubs = [];
      var revenue = [];

      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = this.chartData.chartData[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var item = _step7.value;

          categories.push(moment(item.period).format('MM/YYYY'));
          activeSubs.push(item.activeSubscriptions);
          revenue.push(Number(item.totalRevenue.toFixed(2)));
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      this.activeSubsChart = {
        title: {
          text: 'Total de Assinaturas Ativas'
        },
        xAxis: {
          categories: categories
        }, yAxis: [{
          name: 'Assinaturas Ativas',
          title: {
            text: 'Assinaturas'
          }
        }, {
          title: {
            text: 'Receitas'
          }, opposite: true
        }], series: [{
          colors: ['#FF9900', '#5CB1E6', '#A31717'],
          type: 'pie',
          name: 'Assinaturas por plano',
          data: this.chartData.plans.map(function (x) {
            return { y: x.count, name: x.planName };
          }),
          center: [80, 0],
          size: 120,
          showInLegend: false,
          dataLabels: {
            enabled: false
          }
        }, {
          name: 'Receita no Mês',
          type: 'column',
          yAxis: 1,
          data: revenue,
          tooltip: {
            valuePrefix: 'R$ '
          }
        }, {
          type: 'line',
          yAxis: 0,
          name: 'Assinaturas ativas',
          data: activeSubs
        }]
      };
      this.timeout(function () {
        Highcharts.chart('chart2', _this40.activeSubsChart);
      }, 100);

      this.revenueChart = {
        title: {
          text: 'Receita Mensal'
        },
        xAxis: {
          categories: categories
        }, yAxis: {
          name: 'Receita Mensal',
          title: {
            text: 'Receita'
          }
        }, series: [{
          name: 'Receita no Mês',
          type: 'column',
          yAxis: 0,
          data: revenue,
          tooltip: {
            valuePrefix: 'R$ '
          }
        }]
      };
    }
  }, {
    key: "generateNewVsCanceledChart",
    value: function generateNewVsCanceledChart() {

      var categories = [];
      var newSeries = [];
      var canceledSeries = [];

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = this.chartData.chartData[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var item = _step8.value;

          categories.push(moment(item.period).format('MM/YYYY'));
          newSeries.push(item.newSubscriptions);
          canceledSeries.push(item.canceledSubscriptions);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      this.newVsCanceledChart = {
        colors: ['#5ead5d', '#e55430'],
        chart: {
          type: 'line'
        },
        title: {
          text: 'Novas Assinaturas x Cancelamentos'
        },
        xAxis: {
          categories: categories,
          title: {
            text: 'Meses'
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Assinaturas'
          }
        },
        tooltip: {},
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true
            }
          }
        },
        series: [{
          type: 'column',
          name: 'Novas Assinaturas',
          data: newSeries
        }, {
          type: 'column',
          name: 'Assinaturas Canceladas',
          data: canceledSeries
        }]
      };
    }
  }, {
    key: "initializeStatusTypes",
    value: function initializeStatusTypes() {
      this.statusTypes = [{
        label: 'todos',
        value: 'ALL'
      }, {
        label: 'cobranças no mês',
        value: 'CHARGED'
      }, {
        label: 'pagos',
        value: 'PAID'
      }, {
        label: 'pendentes',
        value: 'PENDING'
      }];

      this.filter.status = 'PAID';
    }
  }, {
    key: "initializeSubscriptionTypes",
    value: function initializeSubscriptionTypes() {
      this.subscriptionTypes = [{
        label: 'novas assinaturas no período',
        field: 'newSubscriptions'
      }, {
        label: 'novas assinaturas desde o lançamento',
        field: 'newSinceLaunch'
      }, {
        label: 'assinaturas canceladas no período',
        field: 'canceled'
      }];
    }
  }, {
    key: "initializePagination",
    value: function initializePagination() {
      this.currentPage = 1;
      this.pageSize = 50;
      this.metadata = null;
    }
  }, {
    key: "changePage",
    value: function changePage(newPage) {
      this.currentPage = newPage;
      this.loadData();
    }
  }, {
    key: "updatePageData",
    value: function updatePageData() {
      this.pageData = this.tableData;
      if (this.metadata) {
        this.pageStart = (this.metadata.page - 1) * this.metadata.limit + 1;
        this.pageEnd = Math.min(this.pageStart + this.pageData.length - 1, this.metadata.total);
      } else {
        this.pageStart = 0;
        this.pageEnd = this.tableData.length;
      }
    }
  }]);

  function RevenueReport2Ctrl($filter, $http, $timeout, config) {
    _classCallCheck(this, RevenueReport2Ctrl);

    this.timeout = $timeout;
    this.dateFilter = $filter('date');
    this.http = $http;
    this.config = config;
    this.initializeMonths();
    this.initializeStatusTypes();
    this.initializeSubscriptionTypes();
    this.initializePagination();

    this.submitChart();
  }

  return RevenueReport2Ctrl;
}();

angular.module('admin.reports').controller('RevenueReport2Ctrl', RevenueReport2Ctrl);
angular.module('admin.reports').constant('dateRangePickerConfig', {
  applyClass: 'btn-sm btn-primary',
  alwaysShowCalendars: true,
  autoApply: true,
  showDropdowns: true,
  locale: {
    applyLabel: 'Aplicar',
    fromLabel: 'De',
    format: 'DD/MM/YYYY',
    toLabel: 'Até',
    cancelLabel: 'Cancelar',
    customRangeLabel: 'Personalizado',
    weekLabel: 'W',
    daysOfWeek: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
  },
  ranges: {
    'Última semana': [moment().subtract(6, 'days'), moment()],
    'Últimos 30 dias': [moment().subtract(30, 'day')],
    'Este mês': [moment().startOf('month'), moment()],
    'Último mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    'Este ano': [moment().startOf('year'), moment()]
  }
}).controller('SubscriptionsFlowReportCtrl', function (dateRangePickerConfig, ReportsResource, $http, config) {
  var _this41 = this;

  var baseColors = ['#5cb1e6', '#ff9900', '#5ead5d', '#8B54DD', '#e55430', '#ff6b6b', '#4ecdc4', '#f9ca24'];

  var generateColors = function generateColors(count) {
    var colors = [];

    for (var i = 0; i < count; i++) {
      if (i < baseColors.length) {
        colors.push(baseColors[i]);
      } else {
        var hue = i * 137.508 % 360;
        colors.push('hsl(' + hue + ', 70%, 50%)');
      }
    }

    return colors;
  };

  var capitalizeString = function capitalizeString(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  this.datePickerOpts = angular.extend(angular.copy(dateRangePickerConfig), {
    eventHandlers: {
      'apply.daterangepicker': function applyDaterangepicker() {
        _this41.loadReport();
      }
    }
  });

  this.filter = {
    period: {
      startDate: moment().subtract(30, 'day').toDate(),
      endDate: moment().toDate()
    }
  };

  this.tablesTabs = [{ action: 'Subscribe', title: 'Assinou' }, { action: 'ChangePlan', title: 'Mudou de Plano' }, { action: 'Unsubscribe', title: 'Cancelou' }, { title: 'Todos' }];

  this.getFilterRequest = function () {
    var filter = angular.copy(this.filter);
    filter.period = {
      startDate: moment(this.filter.period.startDate).format('YYYY-MM-DD'),
      endDate: moment(this.filter.period.endDate).format('YYYY-MM-DD')
    };
    return filter;
  };

  this.loadReport = function () {
    var _this42 = this;

    delete this.report;
    delete this.reportData;
    this.loading = true;

    var filter = this.getFilterRequest();
    delete this.reportAvailable;
    ReportsResource.subscriptionFlow(filter, function (data) {
      _this42.loading = false;
      _this42.report = data;
      if (data.success) {
        _this42.report = data;

        _this42.charts = {
          barChart: _this42.createBarChart(data),
          lineChart: _this42.createLineChart(data),
          pieChart: _this42.createPieChart(data),
          pfVsPjChart: _this42.createPfVsPjPieChart(data)
        };
      }
    });
  };
  this.loadTables = function () {
    var _this43 = this;

    delete this.reportData;
    var filter = this.getFilterRequest();
    this.tableLoading = true;
    ReportsResource.subscriptionFlowData(filter, function (data) {
      _this43.reportData = data;
      _this43.tableLoading = false;
    });
  };

  this.exportTable = function () {
    var action = this.activeTable;

    var filter = Object.assign({
      historyAction: action
    }, this.getFilterRequest());
    $http({
      url: config.api + '/api/AdminSubscriptionFlowReport/GetExcel',
      data: filter,
      method: 'POST',
      responseType: 'arraybuffer'
    }).then(function (res) {
      res.headers();
      var url = URL.createObjectURL(new Blob([res.data], { type: 'arraybuffer' }));
      var a = document.createElement('a');
      a.href = url;
      a.download = "FluxoAssinaturas.xlsx";
      a.target = '_blank';
      a.click();
    });
  };

  this.createBarChart = function (data) {
    var chart = {
      chart: {
        type: 'bar'
      },
      title: {
        text: 'Assinaturas x Cancelamentos'
      },
      xAxis: {
        categories: data.periodReport.categories,
        title: {
          text: null
        }
      },
      yAxis: {
        min: 0
      },
      tooltip: {
        valueSuffix: ''
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true
          }
        }
      },
      series: data.periodReport.series
    };
    return chart;
  };
  this.createLineChart = function (data) {
    var chart = {
      colors: ['#5ead5d', '#8B54DD', '#e55430'],
      chart: {
        type: 'line'
      },
      title: {
        text: 'Evolução Mês a Mês'
      },
      xAxis: {
        categories: data.timeline.categories,
        title: {
          text: 'Meses'
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Qtde'
        }
      },
      tooltip: {
        valueSuffix: ' por mês'
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true
          }
        }
      },
      series: data.timeline.series
    };
    return chart;
  };

  this.createPieChart = function (data) {
    // Converte o objeto de planos dinâmicos em array para o gráfico
    var plansData = [];

    if (data.plans && data.plans.plans) {
      for (var planName in data.plans.plans) {
        if (data.plans.plans.hasOwnProperty(planName)) {
          plansData.push({
            name: capitalizeString(planName),
            y: data.plans.plans[planName]
          });
        }
      }
    }

    return {
      colors: generateColors(plansData.length),
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: 'Novos Planos'
      },
      tooltip: {
        pointFormat: '{series.name}: {point.y} <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      },
      series: [{
        name: 'Planos',
        colorByPoint: true,
        data: plansData
      }]
    };
  };
}).controller('SubscriptionsFlowReportCtrl', function (dateRangePickerConfig, ReportsResource, $http, config, $scope) {
  var _this44 = this;

  this.datePickerOpts = angular.extend(angular.copy(dateRangePickerConfig), {
    eventHandlers: {
      'apply.daterangepicker': function applyDaterangepicker() {
        _this44.loadReport();
      }
    }
  });

  this.filter = {
    period: {
      startDate: moment().subtract(30, 'day').toDate(),
      endDate: moment().toDate()
    }
  };

  this.page = 1;
  this.pageSize = 20;
  this.search = '';
  this.activeTable = 0;
  this.personType = null;

  this.tablesTabs = [{ action: 'SUBSCRIBED', title: 'Assinou' }, { action: 'PLAN_CHANGED', title: 'Mudou de Plano' }, { action: 'CANCELLED', title: 'Cancelou' }, { action: 'ALL', title: 'Todos' }];

  this.getFilterRequest = function () {
    var filter = angular.copy(this.filter);
    filter.period = {
      startDate: moment(this.filter.period.startDate).format('YYYY-MM-DD'),
      endDate: moment(this.filter.period.endDate).format('YYYY-MM-DD')
    };
    return filter;
  };

  this.loadReport = function () {
    var _this45 = this;

    delete this.report;
    delete this.reportData;
    this.loading = true;

    var filter = this.getFilterRequest();
    delete this.reportAvailable;

    var params = {
      startDate: filter.period.startDate,
      endDate: filter.period.endDate
    };
    ReportsResource.subscriptionFlowCharts(params, function (response) {
      _this45.loading = false;
      if (response.statusCode === 200 && response.data) {
        _this45.report = response.data;
        // Set success flag for template compatibility
        _this45.report.success = true;

        _this45.charts = {
          barChart: _this45.createBarChart(response.data),
          lineChart: _this45.createLineChart(response.data),
          pieChart: _this45.createPieChart(response.data),
          pfVsPjChart: _this45.createPfVsPjPieChart(response.data)
        };
      } else {
        // Set report with success false to show the warning message
        _this45.report = { success: false };
      }
    });
  };

  this.loadTables = function () {
    var _this46 = this;

    if (this.tableLoading) return;
    delete this.reportData;

    var filter = this.getFilterRequest();
    this.tableLoading = true;

    var params = {
      startDate: filter.period.startDate,
      endDate: filter.period.endDate,
      page: this.page,
      pageSize: this.pageSize
    };

    var activeTab = this.tablesTabs[this.activeTable];
    if (activeTab && activeTab.action) {
      params.action = activeTab.action;
    }

    if (this.search) {
      params.search = this.search;
    }

    if (this.personType) {
      params.personType = this.personType;
    }

    ReportsResource.subscriptionFlowData(params, function (response) {
      _this46.tableLoading = false;
      if (response.statusCode === 200 && response.data) {
        _this46.reportData = response.data.data;
        _this46.reportMetadata = response.data.metadata;
        return;
      }

      _this46.reportData = [];
      _this46.reportMetadata = { total: 0, page: 1, limit: 20, totalPages: 0 };
    });
  };

  $scope.$watch('ctrl.activeTable', function (newVal, oldVal) {
    if (newVal !== oldVal && !_this44.tableLoading) {
      _this44.page = 1;
      _this44.search = '';
      _this44.loadTables();
    }
  });

  this.onPersonTypeChange = function () {
    this.page = 1;
    this.loadTables();
  };

  this.onPageChange = function () {
    this.loadTables();
  };

  this.onSearch = function () {
    this.page = 1;
    this.loadTables();
  };

  this.exportTable = function () {
    var activeTab = this.tablesTabs[this.activeTable];
    var action = activeTab ? activeTab.action : null;

    var filter = this.getFilterRequest();
    var params = {
      startDate: filter.period.startDate,
      endDate: filter.period.endDate
    };

    if (action) {
      params.action = action;
    }

    if (this.search) {
      params.search = this.search;
    }

    if (this.personType) {
      params.personType = this.personType;
    }

    $http({
      url: config.api + '/api/v1/reports/subscription-flow/export',
      method: 'GET',
      params: params,
      responseType: 'arraybuffer'
    }).then(function (res) {
      var url = URL.createObjectURL(new Blob([res.data], { type: 'arraybuffer' }));
      var a = document.createElement('a');
      a.href = url;
      a.download = "FluxoAssinaturas.csv";
      a.target = '_blank';
      a.click();
    });
  };

  this.createBarChart = function (data) {
    var _chart;

    var chart = (_chart = {
      chart: {
        type: 'bar'
      },
      title: {
        text: 'Assinaturas x Cancelamentos'
      },
      xAxis: {
        categories: ['Assinaturas', "Mudança de Plano", 'Cancelamentos']
      },
      yAxis: {
        title: {
          text: null
        }
      }
    }, _defineProperty(_chart, "yAxis", {
      min: 0
    }), _defineProperty(_chart, "tooltip", {
      valueSuffix: ''
    }), _defineProperty(_chart, "plotOptions", {
      bar: {
        dataLabels: {
          enabled: true
        }
      }
    }), _defineProperty(_chart, "series", [{
      name: 'Valores',
      color: '#7cb5ec',
      data: [data.subscriptionsVsCancellations.subscriptions, data.subscriptionsVsCancellations.planChanges, data.subscriptionsVsCancellations.cancellations]
    }]), _chart);
    return chart;
  };
  this.createLineChart = function (data) {
    var chart = {
      colors: ['#5ead5d', '#8B54DD', '#e55430'],
      chart: {
        type: 'line'
      },
      title: {
        text: 'Evolução Mês a Mês'
      },
      xAxis: {
        categories: data.timeline.categories,
        title: {
          text: 'Meses'
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Qtde'
        }
      },
      tooltip: {
        valueSuffix: ' por mês'
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true
          }
        }
      },
      series: data.timeline.series
    };
    return chart;
  };

  this.createPieChart = function (data) {

    var baseColors = ['#5cb1e6', '#ff9900', '#5ead5d', '#8B54DD', '#e55430', '#ff6b6b', '#4ecdc4', '#45b7d1', '#f9ca24'];

    this.generateColorVariant = function (hexColor, variantIndex) {
      // Convert hex to RGB
      var r = parseInt(hexColor.substr(1, 2), 16);
      var g = parseInt(hexColor.substr(3, 2), 16);
      var b = parseInt(hexColor.substr(5, 2), 16);

      // Adjust brightness: alternate between darker and lighter variants
      var brightnessFactor = variantIndex % 2 === 0 ? 0.7 : 1.3;

      // Apply brightness adjustment
      r = Math.min(255, Math.max(0, Math.round(r * brightnessFactor)));
      g = Math.min(255, Math.max(0, Math.round(g * brightnessFactor)));
      b = Math.min(255, Math.max(0, Math.round(b * brightnessFactor)));

      // Convert back to hex
      var toHex = function toHex(n) {
        var hex = Math.round(n).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      };

      return '#' + toHex(r) + toHex(g) + toHex(b);
    };

    this.generateColorsArray = function (planCount) {
      // Generate colors array: use base colors, then generate variants if needed
      var colors = baseColors.slice();
      if (planCount > baseColors.length) {
        var additionalColorsNeeded = planCount - baseColors.length;
        for (var i = 0; i < additionalColorsNeeded; i++) {
          // Generate dynamic variants by cycling through base colors with varying brightness
          var baseColorIndex = i % baseColors.length;
          var baseColor = baseColors[baseColorIndex];
          var variantIndex = Math.floor(i / baseColors.length) + 1;
          // Create variant by adjusting brightness (darker/lighter)
          var variant = this.generateColorVariant(baseColor, variantIndex);
          colors.push(variant);
        }
      }
      return colors;
    };

    var colors = this.generateColorsArray(data.planDistribution.plans.length);
    var planData = data.planDistribution.plans.map(function (plan) {
      return {
        name: plan.planName,
        y: plan.subscriptions
      };
    });

    return {
      colors: colors,
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: 'Novos Planos'
      },
      tooltip: {
        pointFormat: '{series.name}: {point.y} <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      },
      series: [{
        name: 'Planos',
        colorByPoint: true,
        data: planData
      }]
    };
  };

  this.createPfVsPjPieChart = function (data) {
    return {
      colors: ['#ff9900', '#5cb1e6'],
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: 'Novas Assinaturas: Pessoa Física x Jurídica'
      },
      tooltip: {
        pointFormat: '{series.name}: {point.y} <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      },
      series: [{
        name: 'Planos',
        colorByPoint: true,
        data: [{
          name: 'Pessoa Física',
          y: data.subscriptionTypes.individual
        }, {
          name: 'Pessoa Jurídica',
          y: data.subscriptionTypes.corporate
        }]
      }]
    };
  };

  this.loadReport();
});

angular.module("admin.services").factory("CnpjUtils", function () {
  function clean(value) {
    if (!value) return "";
    return String(value).replace(/[.\/-]/g, "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 14);
  }

  function isAlphanumeric(value) {
    return (/[A-Z]/i.test(String(value || ""))
    );
  }

  function format(value) {
    if (value === null || value === undefined || value === "") {
      return value;
    }

    var raw = clean(value);
    if (!raw) return value;

    if (raw.length <= 2) return raw;
    if (raw.length <= 5) return raw.slice(0, 2) + "." + raw.slice(2);
    if (raw.length <= 8) {
      return raw.slice(0, 2) + "." + raw.slice(2, 5) + "." + raw.slice(5);
    }
    if (raw.length <= 12) {
      return raw.slice(0, 2) + "." + raw.slice(2, 5) + "." + raw.slice(5, 8) + "/" + raw.slice(8);
    }
    return raw.slice(0, 2) + "." + raw.slice(2, 5) + "." + raw.slice(5, 8) + "/" + raw.slice(8, 12) + "-" + raw.slice(12, 14);
  }

  function normalize(value) {
    if (!value) return value;

    var raw = clean(value);
    if (!raw) return value;

    if (isAlphanumeric(raw)) return raw;

    if (raw.length === 13) return "0" + raw;
    return raw.padStart(14, "0");
  }

  function charValue(char) {
    return char.charCodeAt(0) - 48;
  }

  function calcCheckDigit(base) {
    var weights = [2, 3, 4, 5, 6, 7, 8, 9];
    var sum = 0;

    for (var i = base.length - 1; i >= 0; i--) {
      sum += charValue(base[i]) * weights[(base.length - 1 - i) % 8];
    }

    var remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  }

  function hasValidCheckDigits(value) {
    var raw = clean(value);
    if (raw.length !== 14) return false;
    if (/^(.)\1+$/.test(raw)) return false;

    var dv1 = calcCheckDigit(raw.slice(0, 12));
    if (String(dv1) !== raw.charAt(12)) return false;

    var dv2 = calcCheckDigit(raw.slice(0, 12) + dv1);
    return String(dv2) === raw.charAt(13);
  }

  function hasValidFormat(value) {
    if (value === null || value === undefined || value === "") return true;

    var raw = clean(value);
    if (!raw) return true;

    return (/^[A-Z0-9]{1,14}$/.test(raw)
    );
  }

  function isComplete(value) {
    if (value === null || value === undefined || value === "") return true;

    var raw = clean(value);
    if (!raw) return true;

    return raw.length === 14;
  }

  function isValid(value) {
    if (!hasValidFormat(value) || !isComplete(value)) return false;

    var raw = clean(value);
    if (!raw) return true;

    return hasValidCheckDigits(raw);
  }

  return {
    clean: clean,
    format: format,
    normalize: normalize,
    isAlphanumeric: isAlphanumeric,
    hasValidFormat: hasValidFormat,
    isComplete: isComplete,
    hasValidCheckDigits: hasValidCheckDigits,
    isValid: isValid
  };
});

angular.module('admin.services').constant('RemovalReasons', {
  // Mapeamento de códigos para labels
  labels: {
    EXIT_FROM_COMPANY: 'Saída da Empresa',
    DEPARTMENT_CHANGE: 'Mudança de Departamento',
    USER_REPLACEMENT: 'Substituição de Usuário',
    ACCESS_CHANGE: 'Troca de Acesso',
    LICENSES_REDUCTION: 'Redução de Licenças'
  },

  // Função para obter o label de um código
  getLabel: function getLabel(code) {
    if (!code) return '-';
    return this.labels[code] || code;
  },

  // Função para obter o código a partir de um label ou código
  getCode: function getCode(value) {
    if (!value) return null;

    // Se já for um código válido, retorna ele mesmo
    if (this.labels[value]) {
      return value;
    }

    // Normaliza o valor para comparação (remove acentos, espaços extras, etc)
    var normalizedValue = String(value).toLowerCase().trim();

    // Tenta encontrar o código pelo label (comparação case-insensitive)
    for (var code in this.labels) {
      var normalizedLabel = String(this.labels[code]).toLowerCase().trim();
      if (normalizedLabel === normalizedValue) {
        return code;
      }
    }

    // Mapeamento de variações comuns
    var variations = {
      'troca de departamento': 'DEPARTMENT_CHANGE',
      'mudança de departamento': 'DEPARTMENT_CHANGE',
      'saída da empresa': 'EXIT_FROM_COMPANY',
      'substituição de usuário': 'USER_REPLACEMENT',
      'troca de acesso': 'ACCESS_CHANGE',
      'redução de licenças': 'LICENSES_REDUCTION'
    };

    if (variations[normalizedValue]) {
      return variations[normalizedValue];
    }

    // Se não encontrar, retorna o valor original (pode ser um código não mapeado)
    return value;
  }
});

angular.module('admin.services').service('UserManager', function () {

  this.getCurrent = function () {
    return new Promise(function (resolve, reject) {
      // busca usuário que tenha sido gravado durante a sessão.        
      var user = localStorage.getItem('ce-admin-user');
      if (user) {
        user = JSON.parse(user);
        resolve(user);
        return;
      }
      reject();
    });
  };
  this.setCurrent = function (user, _remember) {
    var supervisorData = JSON.stringify(user.data.supervisor);
    localStorage.setItem('ce-admin-user', supervisorData);
    localStorage.setItem('ce-admin-access-token', user.data.accessToken);
    localStorage.setItem('ce-admin-refresh-token', user.data.refreshToken);
    localStorage.setItem('ce-admin-id-token', user.data.idToken);
  };
  this.setTokens = function (idToken, accessToken) {
    localStorage.setItem('ce-admin-id-token', idToken);
    localStorage.setItem('ce-admin-access-token', accessToken);
  };
  this.abandon = function () {
    localStorage.clear();
    this.permissionsSet = false;
  };
});
angular.module('admin.subscriptions').controller('EditOrganizationCtrl', function (organization, $uibModalInstance, $http, config, CnpjUtils) {
  this.organization = Object.assign({}, organization);
  this.organization.cnpj = CnpjUtils.normalize(this.organization.cnpj);

  this.update = function () {

    var data = {
      organizationId: this.organization.id,
      cnpj: CnpjUtils.normalize(this.organization.cnpj)
    };
    $http({
      url: config.api + "/api/v1/user-management/organization/cnpj",
      method: 'PATCH',
      isArray: false,
      data: data
    }).then(function (res) {
      Object.assign(organization, data);
      $uibModalInstance.close();
    });
  };
  this.cancel = function () {
    $uibModalInstance.dismiss();
  };
});
angular.module('admin.subscriptions').controller('ImportUsersCtrl', function ($uibModalInstance, subscription, Upload, config, SubscriptionCustomersImport) {

  this.duplicateActions = [{
    label: 'Associe a esta assinatura',
    value: 'asign'
  }, {
    label: 'Pule este usuário',
    value: 'skip'
  }, {
    label: 'Não faça nada. Aborte a importação',
    value: 'abort'
  }];

  this.request = {
    duplicateAction: 'asign',
    plan: subscription.plans[subscription.plans.length - 1].plan.id,
    number: subscription.number
  };

  this.subscription = subscription;

  this.step = 'file';

  this.selectFile = function (file) {
    this.file = file;
  };

  this.import = function () {
    var _this47 = this;

    this.step = 'progress';
    var req = {
      url: config.api + '/api/AdminSubscriptionUpload/Upload',
      method: 'POST',
      data: this.request,
      file: this.file
    };
    Upload.upload(req).then(function (res) {

      _this47.response = res.data;
      _this47.step = 'progress2';

      _this47.totalUsers = res.data.items.length;
      _this47.processedUsers = 0;

      _this47.updateUsers();
    }, function (err) {});
  };

  this.updateUsers = function () {
    var _this48 = this;

    this.errors = [];

    var updateOne = function updateOne() {
      if (_this48.totalUsers <= _this48.processedUsers) {
        _this48.step = 'finished';
        return;
      }
      var user = _this48.response.items[_this48.processedUsers++];
      if (!user) {
        _this48.step = 'finished';
        return;
      }

      var sci = new SubscriptionCustomersImport({
        number: _this48.subscription.number,
        planId: _this48.request.plan,
        email: user.email
      });

      sci.$save(function () {
        updateOne();
      }, function (err) {
        _this48.errors.push(err.data.message);
        updateOne();
      });
    };

    updateOne();
  };

  this.startOver = function () {
    delete this.file;
    this.step = 'file';
  };

  this.copyTable = function () {
    var table = document.getElementById('tbResults');
    void 0;

    var selection = document.getSelection();
    selection.removeAllRanges();

    var range = document.createRange();
    range.selectNode(table);
    selection.addRange(range);

    document.execCommand('copy');
  };

  this.cancel = function () {
    if (this.response) $uibModalInstance.close();else $uibModalInstance.dismiss();
  };
});
angular.module("admin.subscriptions").controller("SubscriptionDetails", function ($stateParams, $filter, $http, $uibModal, $state, config, SubscriptionDetailsResource, FreePlayResource, ChangeCustomerCredentialsResource, CnpjUtils) {
  var _subscriptionNumber = $stateParams.subscriptionNumber;

  this.userSearch = "";
  this.details = null; // Initialize as null, will be set from API
  this.statusFilter = "ACTIVATED"; // ALL, NEW, ACTIVATED, SUSPENDED - padrão: Ativos
  this.config = config;

  this.subscribersPagination = {
    page: 1,
    pageSize: 24
  };
  this.paginatedSubscribers = [];
  this.allSubscribers = []; // Para contar os status

  this.closeAlert = function (i) {
    this.alerts.splice(i, 1);
  };

  this.formatPhone = function (phone) {
    return Number("" + phone.areaCode + phone.number);
  };

  this.loadDetails = function () {
    var _this49 = this;

    SubscriptionDetailsResource.get({
      subscriptionNumber: _subscriptionNumber
    }, function (response) {
      _this49.details = response.data;
      // TODO: Consider moving the transformation to the back.
      if (_this49.details.administrator && _this49.details.administrator.phone) {
        _this49.details.administrator.phone = _this49.formatPhone(_this49.details.administrator.phone);
      }

      if (_this49.details.administrator && _this49.details.administrator.mobile) {
        _this49.details.administrator.mobile = _this49.formatPhone(_this49.details.administrator.mobile);
      }

      if (_this49.details.organization && _this49.details.organization.phone1) {
        _this49.details.organization.phone1 = _this49.formatPhone(_this49.details.organization.phone1);
      }

      if (_this49.details.organization && _this49.details.organization.phone2) {
        _this49.details.organization.phone2 = _this49.formatPhone(_this49.details.organization.phone2);
      }

      _this49.details.invoiceRecipients = _this49.details.invoiceRecipients.map(function (recipient) {
        return {
          id: recipient.id,
          name: recipient.name,
          email: recipient.email,
          phone: _this49.formatPhone(recipient.phone)
        };
      });

      if (_this49.details.organization && _this49.details.organization.cnpj) {
        _this49.details.organization.cnpj = CnpjUtils.normalize(_this49.details.organization.cnpj);
      }

      _this49.checkExclusion();
      _this49.loadFreeplay();
      _this49.loadSubscribers();
      // this.getTrials();
    }, function (err) {
      _this49.subscriptionNotFound = true;
    });
  };

  this.loadDetails();

  this.getTrials = function () {
    var _this50 = this;

    SubscriptionDetailsResource.getTrials({
      subscriptionNumber: this.details.number
    }, function (data) {
      _this50.trial = data[0];
    });
  };
  this.isTrial = function () {
    if (this.trial && !this.trial.upgradeDate) {
      var d = new Date(this.trial.endDate);
      return d > new Date();
    } else {
      return false;
    }
  };

  this.loadSubscribers = function () {
    var _this51 = this;

    // Reseta a página quando pesquisa
    this.subscribersPagination.page = 1;

    // Prepara os parâmetros
    var params = {
      subscriptionNumber: _subscriptionNumber,
      page: 1,
      limit: 1000, // Carrega muitos para ter todos os dados
      allSubscribers: true // Sempre exibe todos os usuários
    };

    // Adiciona search apenas se houver valor
    if (this.userSearch && this.userSearch.trim()) {
      params.search = this.userSearch.trim();
    }

    // Carrega todos os usuários para contar os status
    SubscriptionDetailsResource.getSubscribers(params, function (response) {
      _this51.allSubscribers = response.data.data || [];
      _this51.subscribersPagination.total = response.data.metadata ? response.data.metadata.total : 0;
      _this51.applyStatusFilter();
    }, function (error) {
      void 0;
      _this51.allSubscribers = [];
      _this51.subscribersPagination.total = 0;
      _this51.applyStatusFilter();
    });
  };

  this.applyStatusFilter = function () {
    var _this52 = this;

    var filtered = [];
    if (this.statusFilter === "ALL") {
      filtered = this.allSubscribers;
    } else {
      filtered = this.allSubscribers.filter(function (user) {
        return user.status && user.status.toUpperCase() === _this52.statusFilter;
      });
    }

    // Aplica paginação local
    var start = (this.subscribersPagination.page - 1) * this.subscribersPagination.pageSize;
    var end = start + this.subscribersPagination.pageSize;
    this.paginatedSubscribers = filtered.slice(start, end);
  };

  this.setStatusFilter = function (status) {
    this.statusFilter = status;
    this.subscribersPagination.page = 1;
    this.applyStatusFilter();
  };

  this.changePage = function () {
    this.applyStatusFilter();
  };

  this.getStatusCount = function (status) {
    // Os contadores já refletem os resultados da pesquisa porque allSubscribers
    // já contém apenas os resultados filtrados pela pesquisa do servidor
    if (!this.allSubscribers || this.allSubscribers.length === 0) return 0;
    if (status === "ALL") return this.allSubscribers.length;
    return this.allSubscribers.filter(function (user) {
      return user.status && user.status.toUpperCase() === status;
    }).length;
  };

  this.selectSubscriber = function (u) {
    var _this53 = this;

    $uibModal.open({
      controller: "EditCustomerModalCtrl",
      templateUrl: "views/customers/edit-customers.html",
      controllerAs: "ctrl",
      backdrop: "static",
      resolve: {
        customer: function customer() {
          return u;
        }
      }
    }).result.then(function () {
      _this53.alerts = [{ type: "success", message: "Os dados foram salvos!" }];
      // Refresh subscribers list after successful update
      if (_this53.details && _this53.details.organization) {
        _this53.loadSubscribers();
      }
    }, function () {});
  };

  this.changeAdmin = function (user) {
    var _this54 = this;

    $uibModal.open({
      component: "changeAdminModal",
      resolve: {
        customer: function customer() {
          return user;
        },
        subscriptionNumber: function subscriptionNumber() {
          return _subscriptionNumber;
        }
      }
    }).result.then(function () {
      return _this54.loadDetails();
    });
  };

  this.deleteCustomer = function (u) {
    var _this56 = this;

    $uibModal.open({
      template: "\n                <div class=\"modal-header\">\n                    <h3>Excluir {{ctrl.customer.firstName}} {{ctrl.customer.lastName}}</h3>\n                </div>\n                <div class=\"modal-body\">\n               <p>\n                    Tem certeza que deseja excluir <strong>{{ctrl.customer.firstName}} {{ctrl.customer.lastName}}</strong>?\n                    </p>\n                </div>\n                <div class=\"modal-footer\">\n                    <button ng-disabled=\"ctrl.working\" type=\"button\" ng-click=\"ctrl.cancel()\" class=\"btn btn-link\">Cancelar</button>\n                    <button  ng-disabled=\"ctrl.working\" type=\"button\" ng-click=\"ctrl.confirmDelete()\" class=\"btn btn-danger\">Sim, excluir {{ctrl.customer.firstName}}</button>\n                </div>\n                ",
      controllerAs: "ctrl",
      controller: function controller(AdminCustomersResource, $uibModalInstance, customer) {
        this.customer = customer;

        this.confirmDelete = function () {
          var _this55 = this;

          this.working = true;
          var request = { id: this.customer.id };
          AdminCustomersResource.deleteCustomer(request, function (res) {
            _this55.working = false;
            $uibModalInstance.close();
          }, function (err) {
            void 0;
            _this55.working = false;
          });
        };
        this.cancel = function () {
          $uibModalInstance.dismiss();
        };
      },
      resolve: {
        customer: function customer() {
          return u;
        }
      }
    }).result.then(function () {
      _this56.loadSubscribers();
    });
  };

  this.checkExclusion = function () {
    var _this57 = this;

    this.canDelete = false;
    $http({
      method: "GET",
      url: config.api + "/api/v1/subscriptions/" + _subscriptionNumber + "/can-delete"
    }).then(function (response) {
      _this57.canDelete = response.data.data.canDelete;
    }, function (err) {});
  };

  this.deleteSubscription = function () {
    if (!this.canDelete) return;

    $uibModal.open({
      template: "\n                <div class=\"modal-header\">\n                    <h3>Excluir Assinatura</h3>\n                </div>\n                <div class=\"modal-body\">\n                Tem certeza que deseja excluir esta assinatura?\n                </div>\n                <div class=\"modal-footer\">\n                    <button ng-click=\"$ctrl.cancel()\" class=\"btn btn-link\">N\xE3o</button>\n                    <button ng-click=\"$ctrl.confirm()\" class=\"btn btn-danger\">SIM, EXCLUIR</button>\n                </div>\n\n                ",
      controllerAs: "$ctrl",
      controller: function controller($uibModalInstance) {
        this.cancel = function () {
          $uibModalInstance.dismiss();
        };
        this.confirm = function () {
          $uibModalInstance.close();
        };
      }
    }).result.then(function () {
      $http({
        method: "DELETE",
        url: config.api + "/api/v1/subscriptions/" + _subscriptionNumber
      }).then(function () {
        $state.go("admin.subscriptions");
      }, function (err) {});
    }, function () {});
  };

  this.exportSubscribers = function () {
    $http({
      url: config.api + ("/api/v1/subscriptions/" + _subscriptionNumber + "/subscribers/export-to-csv"),
      method: "GET",
      responseType: "arraybuffer"
    }).then(function (res) {
      var filename = "ListaUsuarios_" + _subscriptionNumber + ".csv";

      res.headers();
      var url = URL.createObjectURL(new Blob([res.data], { type: "arraybuffer" }));
      var a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.target = "_blank";
      a.click();
    });
  };

  this.loadFreeplay = function () {
    var _this58 = this;

    FreePlayResource.get({
      subscriptionNumber: _subscriptionNumber
    }, function (response) {
      var freeplay = response.data;

      if (!freeplay.id) {
        _this58.freeplay = null;
        _this58.freeplayStatus = null;
        return;
      }

      _this58.freeplay = freeplay;

      var endDate = new Date(freeplay.endDate);
      var startDate = new Date(freeplay.startDate);
      var now = new Date();

      if (startDate > now) {
        _this58.freeplayStatus = "future";
      }

      if (!freeplay.endDate || endDate > now) {
        _this58.freeplayStatus = "valid";
      }

      if (freeplay.endDate && endDate < now) {
        _this58.freeplayStatus = "expired";
      }
    });
  };
}).config(function ($stateProvider) {
  $stateProvider.state("admin.subscriptionDetails", {
    controller: "SubscriptionDetails",
    controllerAs: "ctrl",
    templateUrl: "views/subscriptions/details.html",
    url: "subscription/{subscriptionNumber}",
    data: {
      permissions: {
        only: "admin.subscriptions",
        redirectTo: "admin"
      }
    }
  });
});

angular.module('admin.subscriptions').controller('SubscriptionRevenuesCtrl', function ($uibModal, SubscriptionRevenueResource) {

  this.filter = {
    page: 1,
    pageSize: 20,
    sortDir: 'descending'
  };

  this.paginate = function () {
    var _this59 = this;

    SubscriptionRevenueResource.query(this.filter, function (data) {
      _this59.revenues = data;
    });
  };
  this.search = function () {
    this.filter.page = 1;
    this.paginate();
  };

  this.search();

  this.create = function () {
    var _this60 = this;

    $uibModal.open({
      controller: 'SubscriptionRevenuesEditCtrl',
      controllerAs: 'ctrl',
      templateUrl: 'views/subscriptions/edit_revenue.html',
      resolve: {
        item: function item() {
          return null;
        }
      }
    }).result.then(function () {
      return _this60.search();
    });
  };

  this.edit = function (_item) {
    var _this61 = this;

    $uibModal.open({
      controller: 'SubscriptionRevenuesEditCtrl',
      controllerAs: 'ctrl',
      templateUrl: 'views/subscriptions/edit_revenue.html',
      resolve: {
        item: function item() {
          return _item;
        }
      }
    }).result.then(function () {
      return _this61.search();
    });
  };

  this.remove = function (item) {
    var _this62 = this;

    $uibModal.open({
      controller: function controller($uibModalInstance) {
        this.no = function () {
          $uibModalInstance.dismiss();
        };
        this.yes = function () {
          SubscriptionRevenueResource.remove({
            id: item.id
          }, function () {
            $uibModalInstance.close();
          });
        };
      },
      controllerAs: 'ctrl',
      templateUrl: 'views/subscriptions/delete_revenue.html'
    }).result.then(function () {
      return _this62.paginate();
    });
  };
}).controller('SubscriptionRevenuesEditCtrl', function ($uibModalInstance, SubscriptionRevenueResource, vindiPaymentTypes, item) {
  if (item) {
    this.item = new SubscriptionRevenueResource(item);
    this.item.paidAt = new Date(this.item.paidAt);
  } else {
    this.item = new SubscriptionRevenueResource({
      paymentMethod: 'deposit'
    });
  }

  this.methods = vindiPaymentTypes;

  this.dismiss = function () {
    $uibModalInstance.dismiss();
  };
  this.save = function () {
    this.item.$save(function () {
      return $uibModalInstance.close();
    });
  };
}).config(function ($stateProvider) {
  $stateProvider.state('admin.revenues', {
    controller: 'SubscriptionRevenuesCtrl',
    controllerAs: 'ctrl',
    templateUrl: 'views/subscriptions/revenues.html',
    url: 'subscription_revenues'
  });
});
angular.module("admin.subscriptions").controller("SubscriptionsSummaryCtrl", function (SubscriptionListResource, $uibModal, $scope, CnpjUtils) {
  this.filter = {
    page: 1,
    limit: 10
  };

  this.saveFilter = function () {
    var filter = angular.copy(this.filter);
    var json = JSON.stringify(filter);

    sessionStorage.setItem("admin.subscriptions.filter", json);
  };

  this.restoreFilter = function () {
    var json = sessionStorage.getItem("admin.subscriptions.filter");
    if (json) {
      var filter = JSON.parse(json);
      this.filter = filter;
      if (this.filter.cnpj) {
        this.filter.cnpj = CnpjUtils.normalize(this.filter.cnpj);
      }
    }
  };

  this.clear = function () {
    this.filter = {
      page: 1,
      limit: 10,
      cpf: "",
      cnpj: ""
    };

    if ($scope.frmFilters) {
      $scope.frmFilters.$setPristine();
      $scope.frmFilters.$setUntouched();
    }

    this.loadSubscriptions();
  };

  this.search = function () {
    if ($scope.frmFilters && $scope.frmFilters.$invalid) {
      return;
    }

    this.filter.page = 1;
    this.loadSubscriptions();
  };

  this.appliedFilters = {};

  this.hasSearchFilters = function () {
    return !!(this.appliedFilters.name || this.appliedFilters.email || this.appliedFilters.cpf);
  };

  this.loadSubscriptions = function () {
    var _this63 = this;

    this.saveFilter();

    var query = angular.copy(this.filter);
    if (query.cnpj) {
      query.cnpj = CnpjUtils.normalize(query.cnpj);
    }

    this.appliedFilters = query;

    SubscriptionListResource.query(query, function (response) {
      _this63.subscriptions = response.data;
    }, function (error) {
      _this63.alerts = [{
        type: "danger",
        message: "Não foi possível trazer as assinaturas"
      }];
    });
  };

  this.openImportDialog = function () {
    $uibModal.open({
      templateUrl: "views/trial/trial.html",
      controller: "TrialCtrl",
      size: "lg",
      backdrop: "static",
      controllerAs: "ctrl"
    });
  };

  this.restoreFilter();
  this.loadSubscriptions();
}).config(function ($stateProvider) {
  $stateProvider.state("admin.subscriptions", {
    url: "subscriptions",
    controller: "SubscriptionsSummaryCtrl",
    controllerAs: "ctrl",
    templateUrl: "views/subscriptions/view.html",
    data: {
      permissions: {
        only: "admin.subscriptions"
      }
    }
  });
});

angular.module("admin").controller("CreateUserCtrl", function ($uibModalInstance, SupervisorsResource) {
  this.model = {
    roles: "",
    password: "",
    confirm: ""
  };

  this.roles = [{
    id: "atendimento",
    name: "Comercial"
  }, {
    id: "financeiro",
    name: "Financeiro"
  }, {
    id: "publicidade",
    name: "Marketing"
  }, {
    id: "users",
    name: "Gerenciamento de Usuários"
  }];

  this.bindRolesToModel = function () {
    this.model.roles = this.roles.filter(function (r) {
      return r.selected;
    }).map(function (r) {
      return r.id;
    });
  };

  this.dismiss = function () {
    $uibModalInstance.dismiss();
  };

  this.save = function (frm) {
    var _this64 = this;

    frm.$setSubmitted(true);

    if (frm.$invalid) return;

    this.bindRolesToModel();

    var dataToSave = {
      name: this.model.name,
      email: this.model.email,
      password: this.model.password,
      roles: this.model.roles
    };

    SupervisorsResource.create(dataToSave, function () {
      $uibModalInstance.close();
      _this64.alerts = [];
    }, function (err) {
      _this64.alerts = [{
        message: err.data && err.data.message || "Erro ao criar usuário",
        type: "danger"
      }];
    });
  };
});

angular.module("admin").controller("EditUsersCtrl", function ($uibModalInstance, SupervisorsResource, user) {
  this.model = Object.assign({ roles: "" }, user);

  this.roles = [{
    id: "atendimento",
    name: "Comercial"
  }, {
    id: "financeiro",
    name: "Financeiro"
  }, {
    id: "publicidade",
    name: "Marketing"
  }, {
    id: "users",
    name: "Gerenciamento de Usuários"
  }];

  this.bindModelToRoles = function () {
    var _this65 = this;

    if (!this.model.roles.length) return;

    this.roles.forEach(function (r) {
      r.selected = _this65.model.roles.includes(r.id.toUpperCase());
    });
  };

  this.bindRolesToModel = function () {
    this.model.roles = this.roles.filter(function (r) {
      return r.selected;
    }).map(function (r) {
      return r.id;
    });
  };

  this.bindModelToRoles();

  this.dismiss = function () {
    $uibModalInstance.dismiss();
  };

  this.savePersonalData = function (frm) {
    var _this66 = this;

    frm.$setSubmitted(true);

    if (frm.$invalid) return;

    this.bindRolesToModel();

    var dataToSave = {
      name: this.model.name,
      email: this.model.email,
      roles: this.model.roles
    };

    SupervisorsResource.update({ id: this.model.id }, dataToSave, function () {
      _this66.personalDataSaved = true;
      _this66.alerts = [];
    }, function (err) {
      _this66.alerts = [{
        message: err.data && err.data.message || "Erro ao editar usuário",
        type: "danger"
      }];
    });
  };

  this.savePassword = function (passwordFrm) {
    var _this67 = this;

    passwordFrm.$setSubmitted(true);

    if (passwordFrm.$invalid) return;

    var dataToSave = {
      password: this.passwordModel.password
    };

    SupervisorsResource.changePasswordById({ id: this.model.id }, dataToSave, function () {
      _this67.passwordSaved = true;
      _this67.passwordModel = { password: "", confirm: "" };
      passwordFrm.$setPristine();
      _this67.passwordAlerts = [];
    }, function (err) {
      _this67.passwordAlerts = [{
        message: err.data && err.data.message || "Erro ao alterar senha",
        type: "danger"
      }];
    });
  };

  this.close = function () {
    $uibModalInstance.close();
  };
});

angular.module("admin").controller("ListUsersCtrl", function ($uibModal, SupervisorsResource, $timeout) {
  this.pagination = {
    page: 1,
    pageSize: 10
  };

  this.filters = {
    search: "",
    isActive: "true"
  };

  this.supervisors = [];
  this.metadata = {};
  this.searchTimeout = null;
  this.loading = false;

  this.loadData = function () {
    var _this68 = this;

    this.loading = true;
    var params = {
      page: this.pagination.page,
      limit: this.pagination.pageSize
    };

    if (this.filters.search) {
      params.search = this.filters.search;
    }

    if (this.filters.isActive !== null && this.filters.isActive !== undefined && this.filters.isActive !== "") {
      params.isActive = this.filters.isActive === "true" || this.filters.isActive === true;
    }

    SupervisorsResource.query(params, function (response) {
      _this68.loading = false;
      if (response && response.data) {
        _this68.supervisors = response.data.data || [];
        _this68.metadata = response.data.metadata || {};
      } else {
        _this68.supervisors = [];
        _this68.metadata = {};
      }
    });
  };

  this.onSearchChange = function () {
    var _this69 = this;

    if (this.searchTimeout) {
      $timeout.cancel(this.searchTimeout);
    }
    this.pagination.page = 1;
    this.searchTimeout = $timeout(function () {
      _this69.loadData();
    }, 500);
  };

  this.onFilterChange = function () {
    this.pagination.page = 1;
    this.loadData();
  };

  this.toggle = function (user, e) {
    var _this70 = this;

    e.preventDefault();
    SupervisorsResource.toggle({ id: user.id }, {}, function () {
      _this70.loadData();
    }, function () {
      _this70.loadData();
    });
  };

  this.edit = function (_user, e) {
    var _this71 = this;

    e.preventDefault();
    $uibModal.open({
      controller: "EditUsersCtrl",
      backdrop: "static",
      controllerAs: "ctrl",
      templateUrl: "views/admin/users/edit.html",
      resolve: {
        user: function user() {
          return _user;
        }
      }
    }).result.then(function () {
      return _this71.loadData();
    });
  };

  this.addUser = function (e) {
    var _this72 = this;

    e.preventDefault();

    $uibModal.open({
      controller: "CreateUserCtrl",
      backdrop: "static",
      controllerAs: "ctrl",
      templateUrl: "views/admin/users/create.html"
    }).result.then(function () {
      return _this72.loadData();
    });
  };

  this.loadData();
}).config(function ($stateProvider) {
  $stateProvider.state("admin.users", {
    url: "users",
    templateUrl: "views/admin/users/list.html",
    controllerAs: "ctrl",
    controller: "ListUsersCtrl"
  });
});